import IconCheck from '@assets/checkMark.svg';
import { Box, Flex } from '@styles/flexBox';
import { pageNavigationTypes } from '@utils/enums.js';
import { bounceIn, fadeIn, flipInX, flipInY, jello, pulse, shake, swing, tada, zoomIn } from 'react-animations';
import styled, { createGlobalStyle, css, keyframes } from 'styled-components';

import { fullWidthSection, shadowHard, shadowSoft } from '../../../previewUI/styles/global.js';
import { mainIndent } from '../../../previewUI/utils/constants.js';
// import { Box, Flex } from '@styles/mainStyled';
import { Button, ButtonTransparent } from '../../components/Generics/Button/index.js';
import { PhotoBox } from '../../components/Generics/ShopList/styled.js';
import { getHeightPostLayout, getMiddleGradientColor } from '../../utils/functions.js';

const pulseAnimation = keyframes`${pulse}`;
const shakeAnimation = keyframes`${shake}`;
const tadaAnimation = keyframes`${tada}`;
const bounceInAnimation = keyframes`${bounceIn}`;
const fadeInAnimation = keyframes`${fadeIn}`;
const flipInXAnimation = keyframes`${flipInX}`;
const flipInYAnimation = keyframes`${flipInY}`;
const zoomInAnimation = keyframes`${zoomIn}`;
const swingAnimation = keyframes`${swing}`;
const jelloAnimation = keyframes`${jello}`;

export const Pulse = styled.div`
  width: 100%;
  animation: 5s ${pulseAnimation};
  animation-iteration-count: infinite;

  ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}

  ${(props) =>
    props.mobileView === 1 &&
    css`
      width: calc(33.3% - 6px);
      margin-right: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    `}
    
    ${(props) =>
    props.mobileView === 2 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 4px);
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    css`
      width: calc(50% - 8px);
      //height: 300px;

      @media (max-width: 797px) {
        width: calc(50% - 4px);
        //height: 400px;
      }
    `}

    ${(props) =>
    props.mobileView === 6 &&
    css`
      width: 100%;
    `}
`;

export const Shake = styled.div`
  width: 100%;
  animation: 5s ${shakeAnimation};
  animation-iteration-count: infinite;

  ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}

  ${(props) =>
    props.mobileView === 1 &&
    css`
      width: calc(33.3% - 6px);
      margin-right: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    `}

    ${(props) =>
    props.mobileView === 2 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 4px);
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    css`
      width: calc(50% - 8px);
      //height: 400px;

      @media (max-width: 797px) {
        width: calc(50% - 4px);
        //height: 300px;
      }
    `}

    ${(props) =>
    props.mobileView === 6 &&
    css`
      width: 100%;
    `}
`;

export const Tada = styled.div`
  width: 100%;
  animation: 5s ${tadaAnimation};
  animation-iteration-count: infinite;

  ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}

  ${(props) =>
    props.mobileView === 1 &&
    css`
      width: calc(33.3% - 6px);
      margin-right: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    `}

    ${(props) =>
    props.mobileView === 2 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 4px);
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    css`
      width: calc(50% - 8px);
      //height: 400px;

      @media (max-width: 797px) {
        width: calc(50% - 4px);
        //height: 300px;
      }
    `}

    ${(props) =>
    props.mobileView === 6 &&
    css`
      width: 100%;
    `}
`;

export const BounceIn = styled.div`
  width: 100%;
  animation: 5s ${bounceInAnimation};
  animation-iteration-count: infinite;

  ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}

  ${(props) =>
    props.mobileView === 1 &&
    css`
      width: calc(33.3% - 6px);
      margin-right: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    `}

    ${(props) =>
    props.mobileView === 2 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 4px);
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    css`
      width: calc(50% - 8px);
      //height: 400px;

      @media (max-width: 797px) {
        width: calc(50% - 4px);
        //height: 300px;
      }
    `}

    ${(props) =>
    props.mobileView === 6 &&
    css`
      width: 100%;
    `}
`;

export const FadeIn = styled.div`
  width: 100%;
  animation: 5s ${fadeInAnimation};
  animation-iteration-count: infinite;

  ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}

  ${(props) =>
    props.mobileView === 1 &&
    css`
      width: calc(33.3% - 6px);
      margin-right: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    `}

    ${(props) =>
    props.mobileView === 2 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 4px);
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    css`
      width: calc(50% - 8px);
      //height: 400px;

      @media (max-width: 797px) {
        width: calc(50% - 4px);
        //height: 300px;
      }
    `}

    ${(props) =>
    props.mobileView === 6 &&
    css`
      width: 100%;
    `}
`;

export const FlipInX = styled.div`
  width: 100%;
  animation: 5s ${flipInXAnimation};
  animation-iteration-count: infinite;

  ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}

  ${(props) =>
    props.mobileView === 1 &&
    css`
      width: calc(33.3% - 6px);
      margin-right: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    `}

    ${(props) =>
    props.mobileView === 2 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 4px);
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    css`
      width: calc(50% - 8px);
      //height: 400px;

      @media (max-width: 797px) {
        width: calc(50% - 4px);
        //height: 300px;
      }
    `}

    ${(props) =>
    props.mobileView === 6 &&
    css`
      width: 100%;
    `}
`;

export const FlipInY = styled.div`
  width: 100%;
  animation: 5s ${flipInYAnimation};
  animation-iteration-count: infinite;

  ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}

  ${(props) =>
    props.mobileView === 1 &&
    css`
      width: calc(33.3% - 6px);
      margin-right: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    `}

    ${(props) =>
    props.mobileView === 2 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 4px);
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    css`
      width: calc(50% - 8px);
      //height: 400px;

      @media (max-width: 797px) {
        width: calc(50% - 4px);
        //height: 300px;
      }
    `}

    ${(props) =>
    props.mobileView === 6 &&
    css`
      width: 100%;
    `}
`;

export const ZoomIn = styled.div`
  width: 100%;
  animation: 5s ${zoomInAnimation};
  animation-iteration-count: infinite;

  ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}

  ${(props) =>
    props.mobileView === 1 &&
    css`
      width: calc(33.3% - 6px);
      margin-right: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    `}

    ${(props) =>
    props.mobileView === 2 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 4px);
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    css`
      width: calc(50% - 8px);
      //height: 400px;

      @media (max-width: 797px) {
        width: calc(50% - 4px);
        //height: 300px;
      }
    `}

    ${(props) =>
    props.mobileView === 6 &&
    css`
      width: 100%;
    `}
`;

export const Swing = styled.div`
  width: 100%;
  animation: 5s ${swingAnimation};
  animation-iteration-count: infinite;

  ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}

  ${(props) =>
    props.mobileView === 1 &&
    css`
      width: calc(33.3% - 6px);
      margin-right: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    `}
    

    ${(props) =>
    props.mobileView === 2 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 4px);
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    css`
      width: calc(50% - 8px);
      //height: 400px;

      @media (max-width: 797px) {
        width: calc(50% - 4px);
        //height: 300px;
      }
    `}

    ${(props) =>
    props.mobileView === 6 &&
    css`
      width: 100%;
    `}
`;

export const Jello = styled.div`
  width: 100%;
  animation: 5s ${jelloAnimation};
  animation-iteration-count: infinite;

  ${(props) =>
    props.display &&
    css`
      display: ${props.display};
    `}

  ${(props) =>
    props.mobileView === 1 &&
    css`
      width: calc(33.3% - 6px);
      margin-right: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    `}

    ${(props) =>
    props.mobileView === 2 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 4px);
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    css`
      width: calc(50% - 8px);
      //height: 400px;

      @media (max-width: 797px) {
        width: calc(50% - 4px);
        //height: 300px;
      }
    `}

    ${(props) =>
    props.mobileView === 6 &&
    css`
      width: 100%;
    `}
`;

export const NoAnimate = styled.div`
  width: 100%;

  ${(props) =>
    props.mobileView === 1 &&
    css`
      width: calc(33.3% - 6px);
      margin-right: 8px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    `}

  ${(props) =>
    props.mobileView === 2 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 8px);
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    css`
      width: calc(50% - 8px);

      @media (max-width: 797px) {
        width: calc(50% - 4px);
      }
    `}

    ${(props) =>
    props.mobileView === 8 &&
    props.viewType === 'slider' &&
    css`
      width: 115px;
      height: ${115 + getHeightPostLayout(props.postLayout)}px;

      img {
        object-fit: cover;
        height: 115px !important;
      }

      @media (max-width: 797px) {
        img {
          object-fit: cover;
          height: 115px !important;
        }

        width: 115px;
        height: ${115 + getHeightPostLayout(props.postLayout)}px;
      }
    `}


    ${(props) =>
    props.mobileView === 2 &&
    props.viewType === 'slider' &&
    css`
      width: 180px;
      height: ${180 + getHeightPostLayout(props.postLayout)}px;

      img {
        object-fit: cover;
        height: 180px !important;
      }

      @media (max-width: 797px) {
        img {
          object-fit: cover;
          height: 180px !important;
        }

        width: 180px;
        height: ${180 + getHeightPostLayout(props.postLayout)}px;
      }
    `}

    ${(props) =>
    props.mobileView === 4 &&
    props.viewType === 'slider' &&
    css`
      width: 300px;
      height: ${350 + getHeightPostLayout(props.postLayout)}px;

      img {
        object-fit: cover;
        height: 350px !important;
      }

      @media (max-width: 797px) {
        img {
          object-fit: cover;
          height: 350px !important;
        }

        width: 300px;
        height: ${350 + getHeightPostLayout(props.postLayout)}px;
      }
    `}

    ${(props) =>
    props.mobileView === 7 &&
    props.viewType === 'slider' &&
    css`
      width: 180px;

      img {
        object-fit: cover;
      }

      @media (max-width: 797px) {
        img {
          object-fit: cover;
        }

        width: 180px;
      }
    `}
`;

export const Icons = styled(Box)`
  margin: 20px 0 10px;
  display: flex;
  justify-content: center;
`;

export const PaymentIconFooter = styled.img`
  margin-right: 10px;
  width: 30px;
  height: 30px;

  ${(props) =>
    props.isGooglePay &&
    css`
      margin-left: 10px;
      position: absolute;
      top: -8px;
      left: -10px;
      width: 45px;
      height: 45px;
    `}
`;

export const PaymentIconBox = styled(Box)`
  position: relative;
  width: 30px;
`;

export const PageWrap = styled(Flex)`
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-width: 680px;
  margin-left: auto;
  margin-right: auto;
  box-shadow:
    0 38px 30px 0 rgba(0, 0, 0, 0.025),
    0 30px 60px 0 rgba(0, 0, 0, 0.025);

  min-height: 100vh;

  ${(props) =>
    props.$backgroundColor &&
    css`
      background-color: ${props.$backgroundColor};
    `}

  ${(props) =>
    props.$textColor &&
    css`
      color: ${props.$textColor};
    `}

  ${(props) =>
    props.backgroundImage &&
    css`
      background: none;

      //background: url(${props.backgroundImage}) 0% 20% / 100% no-repeat fixed;

      @media (max-width: 768px) {
        background: none;
      }
    `}

  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  
  
  ${(props) =>
    props.toggle &&
    css`
      margin-right: 0;
    `}

  ${(props) =>
    props.viewPost &&
    css`
      position: fixed;
      transform: translate(-50%, 0);
      left: 50%;
      margin: 0 auto;
      top: 0;
      z-index: 90;
      background: #fff;

      transition: margin 0.35s;

      overflow-x: hidden;

      @media (max-width: 768px) {
        transform: initial;
        left: initial;
        overflow-y: scroll;
        margin: initial;
      }

      // @media (min-width: 992px) {
      //   position: static;
      //   transform: initial;
      //   height: initial;
      // }
    `}

  ${(props) =>
    props.isSubpage &&
    css`
      padding-top: 40px;
    `}

  ${(props) =>
    Boolean(props.backgroundType === 3 && props.filter) &&
    css`
      @media (max-width: 768px) {
        backdrop-filter: ${props.filter};
      }
    `}

  ${(props) =>
    Boolean(props.backgroundType === 3 && props.filter) &&
    props.isInsideDashboard &&
    css`
      backdrop-filter: ${props.filter};
    `}

  ${(props) =>
    props.isInsideDashboard &&
    css`
      min-height: 650px;
    `}
`;

export const UserDataFlex = styled(Flex)`
  justify-content: flex-start;
  align-items: center;
  padding: 3px 12px;
  height: 64px;
  position: relative;
  margin: 0 auto;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  width: 100%;
  max-width: 680px;

  @media (max-width: 768px) {
    left: 0;
    display: flex;
    position: relative;
  }

  @media (min-width: 768px) {
    // padding: 3px 32px;

    ${(props) =>
      props.isInsideDashboard &&
      css`
        pointer-events: none;
        // padding: 3px 10px 3px 12px;
      `}

    ${(props) => props.isInsideDashboard && props.isScroling && css``}


    ${(props) =>
      props.widthWithScroll &&
      css`
        // padding: 3px 12px 3px 30px;
      `}
  }

  @media (max-width: 568px) {
    justify-content: flex-start;
  }

  ${(props) =>
    props.isInsideDashboard &&
    css`
      left: 0;
      display: flex;
      position: relative;
      justify-content: flex-start;
    `}

  ${(props) =>
    props.fixedHeight &&
    css`
      height: 64px;
    `}

  ${(props) =>
    props.isScroling &&
    css`
      padding-top: 3px !important;
      padding-bottom: 3px !important;
    `}

  ${(props) =>
    props.headerThirdType &&
    css`
      padding: 12px 12px 0 !important;
      align-items: flex-start;
      height: 145px;
    `}


  ${(props) =>
    props.isNotButtonThirdType &&
    css`
      height: 105px;
    `}
  ${(props) =>
    props.secondLayout &&
    css`
      height: unset;
    `}
  
  

  ${(props) =>
    props.isPromoBar &&
    css`
      //position: fixed;
      //top: ${props.topIntentPromoBar}px;

      @media (max-width: 768px) {
        //position: absolute;
      }
    `}

  ${(props) =>
    props.isFixed &&
    css`
      position: sticky !important;
      backdrop-filter: blur(10px);
      box-shadow: rgb(10 11 13 / 10%) 0 4px 8px;
    `}
  
  // ${(props) =>
    props.filter &&
    css`
      //   @media (max-width: 768px) {
      //     backdrop-filter: ${props.filter};
      //   }
      //
    `}
  //
  // ${(props) =>
    props.filter &&
    props.isInsideDashboard &&
    css`
      //   backdrop-filter: ${props.filter};
      //
    `}
  //
  ${(props) =>
    props.background &&
    css`
      background: ${props.background};
    `}
  
  // ${(props) =>
    props.backgroundImage &&
    !props.isGradient &&
    css`
      //   background: url(${props.backgroundImage}) 0% 20% / 100% no-repeat fixed;
      //
      //   &:before {
      //     content: "";
      //     position: absolute;
      //     top: 0; left: 0;
      //     width: 100%; height: 100%;
      //
      //     backdrop-filter: ${props.filter};
      //   }
      //
      //   @media (max-width: 768px) {
      //     background: none;
      //   }
      //
    `}

  ${(props) =>
    props.isHideFixedHeader &&
    css`
      visibility: hidden;
    `}

  
  ${(props) =>
    ((props.isBackgroundImage && (props.backgroundType === 3 || props.backgroundType === 4)) || props.backgroundType === 5) &&
    css`
      background: transparent;
      background-image: linear-gradient(180deg, ${props.background}, transparent);
    `}
  
  // ${(props) =>
    props.isGradient &&
    css`
      //   backdrop-filter: none !important;
      //   background-image: ${props.gradient};
      //
    `}
  
  ${(props) =>
    props.viewPost &&
    css`
      z-index: 1;
    `}

  // ${(props) =>
    props.scrollbarWidth &&
    css`
      //   left: -${props.scrollbarWidth}px;
      //
    `}

  ${(props) =>
    props.widthWithScroll &&
    css`
      // width: 106%;
    `}

  ${(props) =>
    Boolean(props.headerLayout === 4 || props.isGradient) &&
    css`
      background: transparent !important;
    `}

  ${(props) =>
    props.headerLayout === 4 &&
    !props.isScroling &&
    css`
      margin-top: -64px;
      top: 64px;
    `}
  

  ${(props) =>
    props.headerLayout === 2 &&
    props.isBio &&
    props.isActiveSomeButton &&
    !props.isScroling &&
    css`
      height: initial;
    `}

  ${(props) =>
    (props.headerLayout === 3 || props.headerLayout === 4 || props.headerLayout === 5) &&
    css`
      justify-content: space-between;

      @media (max-width: 568px) {
        justify-content: space-between;
      }
    `}
`;

export const BasketLayer = styled(Flex)`
  position: fixed;
  bottom: 10px;
  display: flex;
  margin: 0 auto;
  backdrop-filter: none;
  padding: 10px 0 5px 10px;
  transition: all 0.25s;
  left: -4px;
  right: 0;
  z-index: 90;
  width: 100%;
  max-width: 680px;

  @media (max-width: 768px) {
    background: none;
    width: 30%;
    right: 0;
    left: auto;
  }

  ${(props) =>
    props.viewPostMobile &&
    css`
      position: absolute;
      top: -5px;
      right: 10px;
      width: auto;

      @media (max-width: 768px) {
        right: 10px;
        width: auto;
      }
    `}

  ${(props) =>
    props.insideHeader &&
    css`
      position: static;
      width: auto;
      min-width: 35px;
      margin: 0;
      padding: 0;
      border: none;
      //outline: 1px solid red;

      @media (max-width: 768px) {
        background: none;
        width: auto;
        right: 0;
        left: auto;
        border: none;
        margin: 0;
      }
    `}
  
  ${(props) =>
    props.isNoMargin &&
    css`
      padding: 0;

      //@media (max-width: 768px) {
      //  margin: 0;
      //}
    `}

  ${(props) =>
    props.isInsideDashboard &&
    css`
      width: 35px;
      height: 35px;
      right: 0;
      left: auto;
      margin: 0;
    `}
`;

export const BasketStyle = styled(Flex)`
  position: relative;
  border-radius: 50%;
  cursor: pointer;
  border: 1px white solid;
  width: 60px;
  height: 60px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  margin-left: auto;
  z-index: 1000;

  @media (max-width: 568px) {
    margin-right: 11px;
  }

  ${(props) =>
    props.isInsideDashboard &&
    css`
      margin-right: 0;
    `}

  ${(props) =>
    props.cartOpacity &&
    css`
      // opacity: calc(1 - (${props.cartOpacity} / 100)); working for icon too
    `}

    ${(props) =>
    props.backgroundColor &&
    css`
      background: ${props.backgroundColor};
    `}

  ${(props) =>
    props.cartOpacity &&
    css`
      background: ${props.backgroundRGBA};
      border-color: ${props.backgroundRGBA};
    `}

  ${(props) =>
    props.viewPostMobile &&
    css`
      margin: 0;
      width: 50px;
      height: 50px;
      box-shadow: none;
      border: none;
      background-color: transparent;

      @media (max-width: 568px) {
        margin: 0;
        border: none;
      }
    `}

  ${(props) =>
    props.insideHeader &&
    css`
      margin: 0;
      padding: 0;
      width: 35px;
      height: 35px;
      background: ${props.background};
      border: none;
      box-shadow: none;
      padding-bottom: 2px;

      @media (max-width: 568px) {
        margin: 0;
        padding: 0;
        border: none;
        padding-bottom: 2px;
      }
    `}
`;

export const BasketItemsCountStyle = styled(Flex)`
  position: absolute;
  top: -5px;
  right: -5px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #ff0015;

  ${(props) =>
    props.viewPostMobile &&
    css`
      top: -1px;
      right: -1px;
    `}

  ${(props) =>
    props.isHidden &&
    css`
      display: none;
    `}

  ${(props) =>
    props.insideHeader &&
    css`
      top: -5px;
      right: -5px;
    `}
`;

export const CountOnBasket = styled(Flex)`
  margin: auto;
  color: white;
  font-size: 13px;
`;
export const UserDataFlexViewPost = styled(Flex)`
  position: relative;
  padding: 20px 10px;
  justify-content: center;
`;

export const AvatarImg = styled.img`
  display: block;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 0;

  ${(props) =>
    props.headerLayout === 2 &&
    css`
      margin-right: 8px;
      margin-bottom: 12px;
    `}

  ${(props) =>
    props.small &&
    css`
      width: 40px;
      height: 40px;
    `}

  ${(props) =>
    props.big &&
    css`
      width: 72px;
      height: 72px;
    `}

  ${(props) =>
    props.insideBody &&
    css`
      width: 110px;
      height: 110px;

      @media (max-width: 568px) {
        width: 100px;
        height: 100px;
      }
    `}

  ${(props) =>
    props.isInsideDashboard &&
    css`
      width: 100px;
      height: 100px;
    `}

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}

  ${(props) =>
    props.avatarSize &&
    css`
      width: ${props.avatarSize}px;
      height: ${props.avatarSize}px;

      @media (max-width: 568px) {
        width: ${props.avatarSize}px;
        height: ${props.avatarSize}px;
      }
    `}

  ${(props) =>
    props.headerThirdType &&
    css`
      width: 80px;
      height: 80px;
    `}

  ${(props) =>
    (props.headerLayout !== 4 || props.headerLayout !== 5) &&
    props.shape === 'roundedSquare' &&
    css`
      border-radius: 20% !important;

      &:hover {
        border-radius: 20% !important;
      }
    `}

    ${(props) =>
    (props.headerLayout !== 4 || props.headerLayout !== 5) &&
    props.shape === 'square' &&
    css`
      border-radius: 0 !important;

      &:hover {
        border-radius: 0 !important;
      }
    `}

    ${(props) =>
    props.shadow === 'none' &&
    css`
      border: none !important;
      outline: none !important;
    `}

    ${(props) =>
    (props.headerLayout === 2 || props.headerLayout === 3) &&
    props.shadow === 'soft' &&
    props.scrollY < 1 &&
    css`
      ${shadowSoft};
    `}
  
      ${(props) =>
    (props.headerLayout === 2 || props.headerLayout === 3) &&
    props.shadow === 'hard' &&
    props.scrollY < 1 &&
    css`
      box-shadow: ${props.shadowColor} 8px 8px 0 0;
    `}

    ${(props) =>
    props.border === 'solid' &&
    css`
      border: 2px solid ${props.borderColor} !important;

      &:hover {
        border: 2px solid ${props.borderColor} !important;
      }
    `}

  ${(props) =>
    props.border === 'none' &&
    css`
      border: none !important;
      outline: none !important;
    `}

    ${(props) =>
    props.shadow === 'hard' &&
    props.border === 'double' &&
    props.scrollY < 1 &&
    props.headerLayout !== 1 &&
    css`
      box-shadow:
        ${props.shadowColor} 8px 8px 0 0,
        ${props.borderColor} 8px 8px 0 2px;
      border: 2px solid ${props.borderColor} !important;
    `}
      
  ${(props) =>
    props.isMarginRight &&
    css`
      margin-right: 8px;
    `}
`;

export const GradientBox = styled.div`
  display: block;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: -10;
  background-position: center center;
  background-size: cover;

  ${(props) =>
    props.isGradient &&
    css`
      background-image: ${props.gradient};
    `}
`;

export const UserInfoBox = styled(Box)`
  flex: none;
  display: flex;
  text-align: center;
  //flex-grow: 1;
  justify-content: flex-end;
  align-items: center;
  margin-left: auto;

  ${(props) =>
    props.headerThirdType &&
    css`
      margin-top: -22px;
    `}

  ${(props) =>
    props.headerLayout === 2 &&
    css`
      position: absolute;
      top: 12px;
      right: 12px;
    `}
`;

export const UserHeaderMenu = styled(Box)`
  //position: absolute;
  //top: 62px;
  //left: 32px;
  background: #e7e5e4;
  //width: 230px;
  border-radius: 8px;

  @media (max-width: 568px) {
    left: 12px;
  }

  ${(props) =>
    props.insideBody &&
    css`
      top: 210px;
      left: 50%;
      margin-left: -105px;

      @media (max-width: 568px) {
        top: 198px;
        left: 50%;
      }
    `}

  ${(props) =>
    props.isInsideDashboard &&
    css`
      left: 20px;
    `}

  ${(props) =>
    props.insideBody &&
    props.isInsideDashboard &&
    css`
      top: 198px;
    `}
`;

export const UserHeaderMenuList = styled(Box)`
  display: flex;
  flex-direction: column;

  ${(props) =>
    props.withoutLogo &&
    css`
      margin-top: 25px;
    `}

  ${(props) =>
    props.isHide &&
    css`
      display: none;
    `}
`;

export const UserHeaderSignInTitle = styled(Box)`
  position: relative;
  font-size: 22px;
  font-weight: bold;
  text-align: center;
`;

export const UserHeaderArrowBox = styled(Box)`
  position: absolute;
  top: -11px;
  left: 0;
  width: 35px;
  height: 35px;
  cursor: pointer;
`;

export const UserHeaderArrowImg = styled.img``;

export const UserHeaderSignInBox = styled(Box)`
  margin-top: 30px;
  margin-bottom: 0;
  padding: 0 12px;
`;

export const UserHeaderButton = styled(Box)`
  text-align: center;
  min-height: 48px;
  line-height: 48px;
  cursor: pointer;
  margin-top: 10px;
`;

export const UserHeaderButtonText = styled.span`
  flex-grow: 1;
  text-align: center;
`;

export const UserHeaderMenuItem = styled(Box)`
  padding: 15px 15px 15px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #dddcdb;
  cursor: pointer;

  &:hover {
    background: #d5d4d4;
  }

  &:first-child {
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
  }

  &:last-child {
    border-bottom: none;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  ${(props) =>
    props.avatar &&
    css`
      padding: 10px 10px 10px 30px;
    `}

  ${(props) =>
    props.flexStart &&
    css`
      justify-content: flex-start;
    `}
`;

export const UserHeaderMenuTitle = styled(Box)`
  font-size: 15px;

  ${(props) =>
    props.isValue &&
    css`
      margin-right: 10px;
      flex-grow: 1;
      display: flex;
      justify-content: space-between;
    `}
`;

export const UserHeaderMenuIconBox = styled(Box)`
  width: 20px;
  height: 20px;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const UserMessageMenuLink = styled(Box)`
  max-width: 225px;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #3584d6;
  font-weight: bold;

  ${(props) =>
    props.notBold &&
    css`
      font-weight: normal;
      margin-left: 10px;
    `}
`;

export const UserHeaderMenuTitleText = styled(Box)`
  ${(props) =>
    props.isValue &&
    css`
      flex-grow: 1;
      display: flex;
      justify-content: space-between;
    `}
`;

export const UserHeaderMenuTitleValue = styled(Box)`
  font-size: 15px;

  ${(props) =>
    props.green &&
    css`
      color: #69a368;
    `}
`;

export const UserHeaderMenuIconIMG = styled.img`
  width: 21px;
  height: 21px;

  ${(props) =>
    props.avatar &&
    css`
      width: 25px;
      height: 25px;
      border-radius: 50%;
    `}
`;

export const UserHeaderMenuIcon = styled.img`
  width: 17px;
  height: 17px;

  ${(props) =>
    props.avatar &&
    css`
      width: 25px;
      height: 25px;
      border-radius: 50%;
    `}
`;

export const UserInfoBoxViewPost = styled(Box)`
  margin-left: 0;
  display: flex;
  align-items: center;
`;

export const UserNameBox = styled(Box)`
  display: flex;
  flex-direction: column;
  line-height: 32px;
  position: relative;
  top: 0;
  //max-width: 270px;

  ${(props) =>
    props.isButtonWebsite &&
    css`
      //max-width: 380px;

      @media (max-width: 568px) {
        line-height: normal;
        //max-width: 115px;
      }
    `}
  ${(props) =>
    props.isButtonWebsite &&
    props.hide &&
    css`
      @media (max-width: 568px) {
        line-height: normal;
        //max-width: 170px;
      }
    `}

  ${(props) =>
    props.insideBody &&
    css`
      margin-top: 15px;
      display: flex;
      flex-direction: row;
      align-items: center;
    `}

  ${(props) =>
    props.isAlignLeft &&
    css`
      margin: 0;
    `}

  ${(props) =>
    props.center &&
    !props.isAlignLeft &&
    css`
      justify-content: center;
    `}
  
  ${(props) =>
    props.isInsideDashboard &&
    css`
      font-size: 14px;
      line-height: normal;
    `}
  ${(props) =>
    props.isAvatar &&
    css`
      //max-width: 200px;
    `}

  ${(props) =>
    props.isNotFullName &&
    css`
      //max-width: 380px;

      @media (max-width: 568px) {
        line-height: normal;
        //max-width: 380px;
      }
    `}

  ${(props) =>
    props.isWiderDashboard &&
    css`
      //max-width: 380px;

      @media (max-width: 568px) {
        line-height: normal;
        //max-width: 380px;
      }
    `}

  ${(props) =>
    props.headerLayout === 4 &&
    css`
      margin-left: auto;
      margin-right: auto;
      text-align: center;
      justify-content: center;
    `}

  ${(props) =>
    props.headerLayout === 4 &&
    css`
      margin-left: auto;
      margin-right: auto;
      text-align: center;
      justify-content: center;
    `}

  ${(props) =>
    props.headerLayout === 4 &&
    props.scrollY > 1 &&
    css`
      padding-right: 0;
      margin-left: initial;
      margin-right: initial;
    `}
  

  ${(props) =>
    props.headerLayout === 5 &&
    css`
      width: 100%;
    `}

  ${(props) =>
    props.headerLayout === 2 &&
    !props.isShowingCart &&
    css`
      @media (max-width: 568px) {
        //max-width: 230px;
      }
    `}
  
  
  
  
  ${(props) =>
    props.isTop &&
    css`
      top: -2px;
    `}
`;

export const ShortBio = styled(Box)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 15px;
  line-height: 1.5 !important;
  text-align: center;

  ${(props) =>
    props.headerThirdType &&
    css`
      // max-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 4px 0 0 10px;
      text-align: left;
    `}

  ${(props) =>
    props.shortBioSize &&
    css`
      font-size: ${props.shortBioSize}px;
    `}

  ${(props) =>
    props.isMargin &&
    css`
      line-height: 30px;
      margin: 4px 0 0 10px;
    `}


  ${(props) =>
    props.headerThirdType &&
    props.isAvatar &&
    css`
      //max-width: 270px;
    `}

  ${(props) =>
    props.headerLayout === 4 &&
    css`
      max-width: 270px;
      margin: 4px auto 0;
      white-space: initial;
    `}

  ${(props) =>
    (props.headerLayout === 3 || props.headerLayout === 5) &&
    css`
      max-width: 270px;
      margin: 4px auto 0;
      white-space: initial;
    `}

  ${(props) =>
    props.headerLayout === 2 &&
    css`
      white-space: initial;
    `}

  ${(props) =>
    props.isAlignLeft &&
    css`
      text-align: left;
    `}
`;

export const Location = styled(Box)`
  font-size: 15px;
  text-align: center;
  cursor: pointer;
  opacity: 0.8;
  line-height: 1.5;
  max-height: 52px;
  max-width: 100%;
  padding-bottom: 10px;

  ${(props) =>
    props.marginLeft &&
    css`
      margin-left: ${props.marginLeft};
    `}

  ${(props) =>
    props.opacity &&
    css`
      opacity: ${props.opacity};
    `}

  ${(props) =>
    props.isLink &&
    css`
      margin-top: 4px;
      padding: 0 10px;
      color: #385898;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    `}

  ${(props) =>
    props.headerLayout === 2 &&
    css`
      max-width: 300px;
      text-align: left;
      max-height: initial;
      margin-bottom: 5px;
      padding-bottom: 0;
    `}

  ${(props) =>
    (props.headerLayout === 3 || props.headerLayout === 5) &&
    css`
      margin: 4px 0 0;
      max-height: initial;
    `}

  ${(props) =>
    props.headerLayout === 4 &&
    css`
      margin: 4px 0 0;
      max-height: initial;
    `}

  ${(props) =>
    props.isAlignLeft &&
    css`
      padding: 0;
      text-align: left;
    `}
`;

export const LocationIconBox = styled.span`
  position: relative;
  top: 2px;
  margin-right: 3px;
  width: 13px;
  height: 13px;
`;

export const UserNameWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const ContactList = styled(Box)`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  margin-left: -10px;
  padding: 10px 0 0 0;

  ${(props) =>
    props.twoLinePadding &&
    css`
      padding: 10px 0 70px 0;
    `}

  ${(props) =>
    props.noDisplay &&
    css`
      display: none;
    `}

  ${(props) =>
    props.insideBody &&
    css`
      justify-content: center;
      margin: -10px 0 10px 0;
    `}

  ${(props) =>
    props.center &&
    css`
      justify-content: center;
    `}

  ${(props) =>
    props.relative &&
    css`
      position: relative;
      top: 210px;
    `}

  ${(props) =>
    props.isInsideDashboard &&
    css`
      position: relative;
      z-index: 1;
    `}

  ${(props) =>
    props.insideHeader &&
    css`
      padding: 0;
      margin: 0 0 0 10px;
      position: relative;
      top: 0;
    `}

  ${(props) =>
    props.isLessMarginRight &&
    css`
      margin: 0 0 0 7px;
    `}
  
 ${(props) =>
    props.firstLayout &&
    css`
      flex-wrap: wrap;
    `}

 
 ${(props) =>
    props.isWider &&
    css`
      min-width: 200px;
    `}
 
 ${(props) =>
    props.secondLayout &&
    css`
      //max-width: 206px;
    `}
 ${(props) =>
    props.secondLayout &&
    !props.isAvatar &&
    css`
      //max-width: 270px;
    `}
 ${(props) =>
    props.secondLayout &&
    props.isBottom &&
    css`
      //max-width: unset;
    `}
 
  ${(props) =>
    props.isBottom &&
    css`
      margin-top: 16px;
    `}

  ${(props) =>
    props.insideHeader &&
    props.isMarginTop &&
    css`
      margin-top: 5px;
    `}

  ${(props) =>
    props.isRectangleAvatar &&
    css`
      margin-top: 5px;
    `}

  ${(props) =>
    props.headerLayout === 1 &&
    css`
      flex-wrap: wrap;
      height: 23px;
    `}

  ${(props) =>
    props.headerLayout === 4 &&
    css`
      padding-bottom: 0;
    `}

  ${(props) =>
    (props.headerLayout === 3 || props.headerLayout === 5) &&
    css`
      padding-top: 0;
    `}


  ${(props) =>
    props.isInsideDashboard &&
    props.headerLayout === 1 &&
    css`
      height: 23px;
    `}

  ${(props) =>
    props.headerViewType === 2 &&
    props.headerLayout === 5 &&
    css`
      justify-content: flex-start;
      margin: 0;
      padding: 0;
    `}
`;

export const SocialIconBox = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 18px;
  height: 18px;

  ${(props) =>
    props.headerSocialIsCustom &&
    props.headerLayout === 1 &&
    css`
      padding: 2px;
    `}

  ${(props) =>
    props.insideBody &&
    css`
      width: 32px;
      height: 32px;
    `}

  ${(props) =>
    props.isNotFullName &&
    css`
      width: 28px;
      height: 28px;
    `}

  ${(props) =>
    props.isCustomDesign &&
    css`
      width: 28px;
      height: 28px;
    `}

  ${(props) =>
    props.insideHeader &&
    css`
      width: 24px;
      height: 24px;
    `}


  ${(props) =>
    props.headerLayout === 2 &&
    css`
      width: 28px;
      height: 28px;
    `}
  ${(props) =>
    props.headerLayout === 5 &&
    props.headerViewType === 2 &&
    css`
      width: 26px;
      height: 26px;
    `}
`;

export const SocialIcon = styled.img`
  width: 18px;
  height: 18px;

  ${(props) =>
    props.insideBody &&
    css`
      width: 32px;
      height: 32px;
    `}

  ${(props) =>
    props.mediumSize &&
    css`
      width: 28px;
      height: 28px;
    `}

   ${(props) =>
    props.smallSize &&
    css`
      width: 18px;
      height: 18px;
    `}


  

  ${(props) =>
    props.bgColor &&
    css`
      fill: ${props.bgColor};
    `}

  ${(props) =>
    props.headerLayout === 5 &&
    props.headerViewType === 2 &&
    css`
      width: 26px;
      height: 26px;
    `}
`;

export const ContactBox = styled.div`
  margin-bottom: 20px;
  margin-left: 11px;
  margin-right: 11px;

  flex: none;
  display: block;
  width: 32px;
  height: 32px;

  cursor: pointer;
  border-radius: 8px;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  svg {
    width: 32px;
    height: 32px;
  }

  ${(props) =>
    props.shape === 'roundedSquare' &&
    css`
      border-radius: 20% !important;

      &:hover {
        border-radius: 20% !important;
      }
    `}

  ${(props) =>
    props.shape === 'square' &&
    css`
      border-radius: 0 !important;

      &:hover {
        border-radius: 0 !important;
      }
    `}

  ${(props) =>
    (props.headerLayout === 3 || props.headerLayout === 4 || props.headerLayout === 5) &&
    css`
      &:first-child {
        margin-left: 11px;
      }

      &:last-child {
        margin-right: 11px;
      }
    `}

  ${(props) =>
    props.isBottom &&
    css`
      &:first-child {
        margin-left: 11px;
      }

      &:last-child {
        margin-right: 11px;
      }
    `}

  ${(props) =>
    props.insideHeader &&
    css`
      width: 16px;
      height: 16px;
      padding: 0;
      margin-bottom: 5px;
      margin-left: 0;
      margin-right: 5px;

      svg {
        width: 18px;
        height: 18px;
      }
    `}

  ${(props) =>
    props.insideBody &&
    css`
      width: 32px;
      height: 32px;

      svg {
        width: 32px;
        height: 32px;
      }
    `}


  ${(props) =>
    props.isNotFullName &&
    css`
      width: 28px;
      height: 28px;
      margin: 0 3px 0 0;

      svg {
        width: 28px;
        height: 28px;
      }
    `}

  ${(props) =>
    props.isNotFullName &&
    props.isWider &&
    css`
      margin: 0 8px 0 0;
    `}

  ${(props) =>
    props.headerLayout === 4 &&
    css`
      margin-bottom: 12px;
    `}


  ${(props) =>
    props.isCustomDesign &&
    css`
      width: 45px;
      height: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background: ${props.background};

      svg {
        width: 28px;
        height: 28px;
      }
    `}

 

  ${(props) =>
    props.noDisplay &&
    css`
      display: none;
    `}

  ${(props) =>
    props.isCustomDesign &&
    props.insideHeader &&
    css`
      width: 18px;
      height: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background: ${props.background};
      border: 2px solid ${props.background};

      svg {
        width: 18px;
        height: 18px;
      }
    `}

  ${(props) =>
    props.isCustomDesign &&
    props.isBorder &&
    css`
      outline: 0.5px solid ${props.color};
    `}

    ${(props) =>
    props.isCustomDesign &&
    props.border === 'solid' &&
    css`
      outline: 0.5px solid ${props.color};
    `}

    ${(props) =>
    props.isCustomDesign &&
    props.border === 'none' &&
    css`
      outline: none;
    `}


  ${(props) =>
    props.headerLayout === 2 &&
    css`
      margin-bottom: 8px;
      width: 28px;
      height: 28px;
    `}

  ${(props) =>
    props.isScroling &&
    css`
      margin-bottom: 6px;
    `}

  ${(props) =>
    props.isCustomDesign &&
    props.headerLayout === 1 &&
    css`
      margin-top: 3px;
      margin-bottom: 3px;
    `}

  ${(props) =>
    props.headerLayout === 5 &&
    props.headerViewType === 2 &&
    css`
      width: 26px;
      height: 26px;
      margin-left: 7px;
      margin-right: 7px;

      &:first-child {
        margin-left: 7px;
      }

      &:last-child {
        margin-right: 7px;
      }
    `}
`;

export const UserNameTitle = styled(Box)`
  min-height: 24px;
  overflow: hidden;

  margin: 0;
  font-size: 15px;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 568px) {
    font-size: 15px;
    line-height: 26px;
  }

  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}
  ${(props) =>
    props.fullNameBold &&
    css`
      font-weight: ${props.fullNameBold};
    `}

  ${(props) =>
    props.insideBody &&
    css`
      margin: 0;
    `}

  ${(props) =>
    props.inline &&
    css`
      display: inline;
    `}

  ${(props) =>
    props.viewPostMobile &&
    css`
      font-size: 15px;
      text-transform: uppercase;
      margin: 0;

      @media (max-width: 568px) {
        font-size: 15px;
        line-height: 26px;
      }
    `}

  ${(props) =>
    props.isUppercase &&
    css`
      text-transform: uppercase;
    `}

  ${(props) =>
    props.fullNameSize &&
    css`
      font-size: ${props.fullNameSize}px;
      line-height: 1.2;

      @media (max-width: 568px) {
        font-size: ${props.fullNameSize}px;
        line-height: 1.2;
      }
    `}

  ${(props) =>
    props.headerThirdType &&
    css`
      font-size: 20px;
      line-height: 1.2;

      @media (max-width: 568px) {
        font-size: 20px;
        line-height: 1.2;
      }
    `}

  ${(props) =>
    props.headerLayout === 2 &&
    css`
      text-overflow: initial;
      white-space: initial;
      overflow: initial;
      height: initial;
    `}


  ${(props) =>
    props.headerLayout === 4 &&
    css`
      word-wrap: break-word;
      overflow: unset;
      text-overflow: unset;
      white-space: unset;
      text-align: center;
    `}

  ${(props) =>
    props.headerLayout === 3 &&
    css`
      height: initial;
      word-wrap: break-word;
      overflow: unset;
      text-overflow: unset;
      white-space: unset;
      text-align: center;
    `}

  ${(props) =>
    props.headerLayout === 4 &&
    css`
      height: initial;
    `}

  ${(props) =>
    props.headerThirdType &&
    props.isAvatar &&
    css`
      //max-width: 270px;
    `}


  ${(props) =>
    props.scrollY > 0 &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      @media (max-width: 568px) {
        font-size: 15px;
      }
    `}
`;

export const UserNameText = styled(Box)`
  line-height: 1.7;
  position: relative;
  display: flex;
  align-items: center;

  margin-left: 10px;

  //@media (max-width: 568px) {
  //  max-width: 150px;
  //}

  ${(props) =>
    props.hidden &&
    css`
      display: none;
    `}

  ${(props) =>
    props.isHideAvatar &&
    css`
      margin-left: 0;
    `}
  

  ${(props) =>
    props.headerThirdType &&
    css`
      @media (max-width: 568px) {
        //max-width: 199px;
      }
    `}

  ${(props) =>
    props.headerThirdType &&
    !props.isShowingCart &&
    css`
      @media (max-width: 568px) {
        //max-width: 230px;
      }
    `}
`;

export const UserVerifiedIcon = styled.img`
  flex: none;
  position: relative;
  top: 0;
  left: 0;
  width: 22px;
  height: 22px;
  margin-left: 3px;
`;

export const UserVerifiedIconViewPost = styled.img`
  position: relative;
  top: 2px;
  margin-left: 10px;
  width: 25px;
  height: 25px;
`;

export const UserLinkBox = styled(Box)`
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: end;
  margin: 8px 0 8px 10px;

  @media (max-width: 568px) {
    margin: 8px 0 8px 5px;
  }

  ${(props) =>
    props.isWider &&
    css`
      width: 80%;
    `}

  ${(props) =>
    props.isHalfWidth &&
    css`
      width: 100%;
    `}

  ${(props) =>
    props.isInsideDashboard &&
    css`
      margin: 8px 0 8px 5px;
    `}

  ${(props) =>
    props.headerLayout === 2 &&
    css`
      margin: 0;

      @media (max-width: 568px) {
        margin: 0;
      }
    `}
`;

export const UserLinkA = styled.a`
  text-decoration: none;
  font-weight: bold;
  color: ${(props) => props.textColor ?? '#3985c1'};
  ${(props) =>
    props.isMap &&
    css`
      display: block;
      font-weight: normal;
      text-align: center;
    `}
`;

export const UserHeader = styled(Box)`
  margin-bottom: ${mainIndent};
  position: relative;

  ${(props) =>
    props.fiveView &&
    css`
      margin-bottom: 100px;
      position: relative;
      top: 0;
      height: 118px;
      z-index: -1;
    `}

  ${(props) =>
    props.sixthView &&
    css`
      position: absolute;
      top: 0;
      left: 0;
      height: 118px;
      z-index: -1;
    `}

  ${(props) =>
    props.isInsideDashboard &&
    css`
      z-index: 0;
    `}

  ${(props) =>
    props.sixthView &&
    props.isInsideDashboard &&
    css`
      width: 100%;
    `}

  ${(props) =>
    props.isShowing &&
    css`
      display: block;
    `}



  ${(props) =>
    props.bannerHeightView === 'custom' &&
    css`
      position: relative;
      height: ${props.bannerHeight}px;
    `}
  
  

  ${(props) =>
    props.isVideo &&
    css`
      height: auto;
    `}

  ${(props) =>
    props.isFullWidth &&
    css`
      margin-left: -12px;
      margin-right: -12px;
    `}
`;

export const HeaderCoverBox = styled(Box)`
  margin-bottom: ${mainIndent};

  ${(props) =>
    props.isInsideDashboard &&
    css`
      z-index: 0;
    `}

  ${(props) =>
    props.height &&
    css`
      position: relative;
      height: ${props.height}px;
    `}


  ${(props) =>
    props.headerLayout === 2 &&
    css`
      position: absolute;
      top: 0;
    `}
`;

export const UserHeaderImg = styled.img`
  margin: 0 auto;
  display: block;
  width: 100%;
  max-width: 768px;
  border-radius: 10px;
  height: 400px;

  @media (max-width: 568px) {
    height: 300px;
    width: 100%;
  }

  ${(props) =>
    props.banner &&
    css`
      max-width: 660px;
    `}

  ${(props) =>
    props.bannerLayout &&
    css`
      height: 200px;
      width: 100%;
      border-radius: 0;

      @media (max-width: 568px) {
        height: 200px;
      }
    `}

  ${(props) =>
    props.bannerLayout &&
    props.isInsideDashboard &&
    css`
      width: 100% !important;
    `}
  
  ${(props) =>
    props.isInsideDashboard &&
    css`
      height: 200px;
    `}
  
  ${(props) =>
    props.bannerHeight &&
    props.bannerHeightView === 'custom' &&
    css`
      height: ${props.bannerHeight}px !important;
      object-fit: cover;
    `}

  ${(props) =>
    Boolean(props.darkness) &&
    css`
      filter: brightness(${100 - props.darkness}%);
    `}
  
  ${(props) =>
    props.bannerHeightView === 'original' &&
    css`
      height: auto;
      object-fit: initial;

      @media (max-width: 568px) {
        height: auto;
      }
    `}

  ${(props) =>
    props.bannerHeightView === 'square' &&
    css`
      object-fit: cover;
      height: calc(100vw - 24px);
      max-height: 680px;

      @media (max-width: 568px) {
        height: calc(100vw - 24px);
      }
    `}


  ${(props) =>
    props.bannerHeightView === 'square' &&
    props.isInsideDashboard &&
    css`
      object-fit: cover;
      height: 309px;
      max-height: 309px;

      @media (max-width: 568px) {
        height: 309px;
      }
    `}
`;

export const HeaderCoverImg = styled.img`
  display: block;
  // max-width: 768px; TODO header cover testing
  max-width: 111%;
  height: auto;
  object-fit: cover;
  width: 101vw !important;
  margin-left: -34px;

  @media (max-width: 568px) {
    margin-left: -14px;
  }

  ${(props) =>
    props.height &&
    css`
      height: ${props.height}px !important;
    `}

  ${(props) =>
    props.isInsideDashboard &&
    css`
      width: 330px !important;
      margin-left: -12px;
    `}
    
    ${(props) =>
    props.headerLayout === 2 &&
    css`
      margin-left: 0;
      max-width: 680px;

      @media (max-width: 568px) {
        margin-left: 0;
      }
    `}

    ${(props) =>
    props.headerLayout === 2 &&
    props.isInsideDashboard &&
    css`
      margin-left: 0;
    `}

  ${(props) =>
    props.darkness &&
    css`
      filter: brightness(${100 - props.darkness}%);
    `}
`;

export const HeaderCoverVideo = styled.video`
  display: block;
  max-width: 768px;
  height: auto;
  object-fit: cover;
  width: 101vw !important;
  margin-left: -34px;

  @media (max-width: 568px) {
    margin-left: -14px;
  }

  ${(props) =>
    props.height &&
    css`
      height: ${props.height}px !important;
    `}

  ${(props) =>
    props.isInsideDashboard &&
    css`
      width: 330px !important;
      margin-left: -14px;
    `}

  ${(props) =>
    props.darkness &&
    css`
      filter: brightness(${100 - props.darkness}%);
    `}
`;

export const HeaderButtonsBox = styled(Box)`
  display: flex;
  gap: 10px;
  justify-content: space-between;
  align-items: center;

  ${(props) =>
    props.justifyContent &&
    css`
      justify-content: ${props.justifyContent};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const HeaderCoverAvatarBox = styled(Box)`
  position: relative;
  height: 462px;
`;

export const ShopWrapper = styled(Box)`
  margin-bottom: ${mainIndent};
  margin-top: ${mainIndent};
`;

export const HeaderCoverAvatar = styled.img`
  display: block;
  max-width: 685px;
  //height: 414px;
  height: 462px;
  object-fit: cover;
  width: 101vw !important;
  margin-left: -34px;

  @media (max-width: 568px) {
    margin-left: -14px;
  }

  ${(props) =>
    props.isInsideDashboard &&
    css`
      width: 330px !important;
      margin-left: -12px;
    `}

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}
`;

export const HeaderDirectButton = styled(Button)`
  padding: 0;
  width: 180px;
  max-width: 306px;
  height: 34px;
  max-height: 34px;
  min-height: 34px;
  margin: 0;
  font-size: 14px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${(props) =>
    props.isMarginLeft &&
    css`
      margin-left: 15px;
    `}
  

  ${(props) =>
    props.background &&
    css`
      background: ${props.background};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    (props.headerLayout === 3 || props.headerLayout === 4 || props.headerLayout === 5) &&
    css`
      width: 47%;
      border-color: transparent;
    `}

  ${(props) =>
    props.isFullWidth &&
    css`
      width: 100%;
    `}

  ${(props) =>
    props.shape === 'square' &&
    css`
      border-radius: 2px;
    `}


  ${(props) =>
    props.shadow === 'soft' &&
    css`
      ${shadowSoft};
    `}

  ${(props) =>
    props.sectionBorder === 'solid' &&
    css`
      border: 2px solid ${props.sectionBorderColor};
    `}


  ${(props) =>
    props.shadow === 'hard' &&
    css`
      box-shadow: ${props.shadowColor} 8px 8px 0 0;
    `}

  ${(props) =>
    props.shadow === 'hard' &&
    props.sectionBorder === 'double' &&
    css`
      box-shadow:
        ${props.shadowColor} 8px 8px 0 0,
        ${props.sectionBorderColor} 8px 8px 0 2px;
      border: 2px solid ${props.sectionBorderColor};
    `}

  ${(props) =>
    props.sectionShadow &&
    css`
      box-shadow: ${props.sectionShadow};
    `}
`;

export const HeaderCoverAvatarContent = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 101vw !important;
  max-width: 685px;
  margin-left: -34px;
  padding: 25px 12px 10px;

  @media (max-width: 568px) {
    margin-left: -14px;
  }

  ${(props) =>
    props.bgRGB &&
    css`
      background: linear-gradient(
        rgba(${props.bgRGB?.r}, ${props.bgRGB?.g}, ${props.bgRGB?.b}, 0) 0%,
        rgba(${props.bgRGB?.r}, ${props.bgRGB?.g}, ${props.bgRGB?.b}, 0.78) 51.04%,
        rgb(${props.bgRGB?.r}, ${props.bgRGB?.g}, ${props.bgRGB?.b}) 100%
      );
    `}

  ${(props) =>
    props.avatarGradient &&
    css`
      background: linear-gradient(
        ${getMiddleGradientColor(props.avatarGradient, 0)} 0%,
        ${getMiddleGradientColor(props.avatarGradient, 0.78)} 51.04%,
        ${getMiddleGradientColor(props.avatarGradient, 1)} 100%
      );
    `}

  // ${(props) =>
    props.bgRGB &&
    props.isGradient &&
    css`
      //   background: linear-gradient(
      //           rgba(${props.bgRGB?.r}, ${props.bgRGB?.g}, ${props.bgRGB?.b}, 0) 0%,
      //           rgba(${props.bgRGB?.r}, ${props.bgRGB?.g}, ${props.bgRGB?.b}, 0.78) 51.04%,
      //           #e8e1ea 100%);
      //
    `}

  ${(props) =>
    props.isInsideDashboard &&
    css`
      width: 330px !important;
      max-width: 330px;

      margin-left: -12px;
    `}

  ${(props) =>
    props.isNoAvatar &&
    css`
      background: transparent;
      bottom: unset;
      top: 0;
    `}
`;

export const HeaderBodyCTABox = styled(Box)`
  display: flex;
  margin: 0;
  justify-content: center;
  width: 47%;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.isFullWidth &&
    css`
      width: 100%;
    `}
`;

export const UserHeaderVideoBox = styled(Box)`
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: auto;
  margin-bottom: 10px;

  ${(props) =>
    props.youTubeVideo &&
    css`
      position: relative;
      z-index: 1;
      width: 100%;
      height: 100%;
      padding: 0;
      border-radius: 10px;
    `}

  ${(props) =>
    props.shape === 'square' &&
    css`
      border-radius: 8px !important;

      &:hover {
        border-radius: 8px !important;
      }
    `}
    
      ${(props) =>
    props.shape === 'round' &&
    css`
      border-radius: 36px !important;

      &:hover {
        border-radius: 36px !important;
      }
    `}
  
        ${(props) =>
    props.border === 'solid' &&
    css`
      border: 2px solid ${props.borderColor} !important;

      &:hover {
        border: 2px solid ${props.borderColor} !important;
      }
    `}
        ${(props) =>
    props.border === 'none' &&
    css`
      border: none !important;
      outline: none !important;
    `}
    
          ${(props) =>
    props.shadow === 'hard' &&
    css`
      box-shadow: ${props.shadowColor} 8px 8px 0 0;
    `}
          ${(props) =>
    props.shadow === 'soft' &&
    css`
      ${shadowSoft};
    `}
      
          ${(props) =>
    props.shadow === 'hard' &&
    props.border === 'double' &&
    css`
      box-shadow:
        ${props.shadowColor} 8px 8px 0 0,
        ${props.borderColor} 8px 8px 0 2px;
      border: 2px solid ${props.borderColor} !important;
    `}
`;

export const SectionBox = styled(Box)`
  padding: 10px 12px;
  border-radius: 8px;

  .swiper {
    width: 100% !important;
  }

  ${(props) =>
    props.isInsideFooter &&
    css`
      // padding-top: 10px;
      margin-bottom: 0;
    `}

  ${(props) =>
    props.shape === 'square' &&
    css`
      border-radius: 2px;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  ${(props) =>
    props.background &&
    css`
      background: ${props.background};
    `}

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}
  ${(props) =>
    props.banner &&
    css`
      padding: 20px 0;
    `}

  ${(props) =>
    props.isBorder &&
    css`
      border: 1px solid ${props.color};
    `}
  ${(props) =>
    props.sectionBorder === 'solid' &&
    css`
      border: 2px solid ${props.sectionBorderColor};
    `}

  ${(props) =>
    props.borderStyle &&
    css`
      border: ${props.borderStyle};
    `}

    ${(props) =>
      props.isFullWidth &&
      css`
        ${fullWidthSection};
      `}

  ${(props) =>
    props.isFullWidth &&
    props.isInsideDashboard &&
    css`
      padding-left: 32px;
      padding-right: 32px;
    `}

    ${(props) =>
      props.isInsideDashboard &&
      css`
        pointer-events: none;
      `}

    ${(props) =>
      props.shadow === 'soft' &&
      css`
        ${shadowSoft};
      `}

  ${(props) =>
    props.shadow === 'hard' &&
    css`
      box-shadow: ${props.shadowColor} 8px 8px 0 0;
    `}

  ${(props) =>
    props.shadow === 'hard' &&
    props.sectionBorder === 'double' &&
    css`
      box-shadow:
        ${props.shadowColor} 8px 8px 0 0,
        ${props.sectionBorderColor} 8px 8px 0 2px;
      border: 2px solid ${props.sectionBorderColor};
    `}

  ${(props) =>
    props.sectionShadow &&
    css`
      box-shadow: ${props.sectionShadow};
    `}


  ${(props) =>
    props.sectionMargin &&
    css`
      margin-top: ${props.sectionMargin}px;
      margin-bottom: ${props.sectionMargin}px;
    `}

    ${(props) =>
      props.marginTop &&
      css`
        margin-top: ${props.marginTop}px;
        margin-bottom: 0;
      `}

  ${(props) =>
    props.sectionPadding &&
    css`
      padding-top: ${props.sectionPadding}px;
      padding-bottom: ${props.sectionPadding}px;
    `}
    
    .ql-container.ql-snow {
    border: none !important;
  }

  .ql-editor {
    padding-bottom: 0 !important;
    overflow: hidden !important;
  }
  
  ${(props) =>
    props.footer &&
    css`
      margin-top: 70px;
      background: #fff;
      color: #000;

      width: calc(100% + 70px);
      margin-left: -34px;
      padding: 50px 32px 0 32px;

      @media (max-width: 568px) {
        width: 101vw !important;
        margin-left: -14px;
        padding: 50px 12px 12px;
      }
    `}

  }


`;

export const Item = styled(Box)`
  width: 100%;

  ${(props) =>
    props.minHeight &&
    css`
      min-height: ${props.minHeight};
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.slider &&
    css`
      width: 327px;
      height: 184px;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const List = styled(Box)`
  margin: ${mainIndent} 0;
`;

export const CustomSpan = styled(Box)`
  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.flex &&
    css`
      display: flex;
    `}
`;

export const UserHeaderVideo = styled.iframe`
  left: 0;
  top: 0;
  line-height: 1.2;
  height: 100%;
  width: 100%;
  position: absolute;

  border-radius: 10px;
`;

export const UserHeaderTitle = styled(Box)`
  padding: 0 5px;
  font-weight: bold;
  word-wrap: break-word;
  overflow: hidden;

  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}

  ${(props) =>
    props.lineHeight &&
    css`
      line-height: ${props.lineHeight}%;
    `}

  ${(props) =>
    props.size &&
    css`
      font-size: ${props.size}px;
      width: auto;
      height: auto;
    `}

  ${(props) =>
    props.isInsideDashboard &&
    css`
      position: relative;
      z-index: 1;
    `}

  ${(props) =>
    props.isInsideBio &&
    css`
      padding: 0 12px 10px;
    `}

  ${(props) =>
    props.isNotText &&
    css`
      margin-bottom: 15px;
    `}

  ${(props) =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}
`;

export const UserTimerHeaderBox = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${(props) =>
    props.hidden &&
    css`
      position: absolute;
      opacity: 0;
      z-index: -1;
    `}
`;

export const UserTimerIcon = styled.svg`
  margin-right: 10px;
  width: 35px;
  height: 35px;

  @media (max-width: 568px) {
    width: 30px;
    height: 30px;
  }

  ${(props) =>
    props.isInsideDashboard &&
    css`
      width: 30px;
      height: 30px;
    `}
`;

export const UserTimer = styled(Box)`
  padding: 0 15px;
  margin: ${mainIndent} 0;

  ${(props) =>
    props.insideHeader &&
    css`
      margin: 0;
      padding: 0;
    `}
`;

export const TimerBox = styled(Box)`
  min-width: 225px;
  width: max-content;
  padding: 15px;
  margin: 25px auto;
  border-radius: 8px;
  text-align: center;

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${(props) =>
    props.bgColor &&
    css`
      background: ${props.bgColor};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const TimerLabel = styled(Box)`
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 10px;
  text-transform: uppercase;
  width: max-content;
  margin: 0 auto;
  padding: 1px 3px;
  border-radius: 1px;

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${(props) =>
    props.bgColor &&
    css`
      background: ${props.bgColor};
    `}
`;

export const TimerTitleBox = styled(Box)`
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TimerIcon = styled.img`
  margin-right: 3px;
  width: 20px;
  height: 20px;
`;

export const TimerTitle = styled(Box)`
  font-size: 16px;
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TimerWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HeaderSubstrate = styled(Box)`
  border-radius: 8px;
  padding: 26px 0;
  margin: ${mainIndent} 0;

  .ql-container.ql-snow {
    border: none !important;
  }

  ${(props) =>
    props.minHeight &&
    css`
      min-height: ${props.minHeight}px;
    `}

  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}

  ${(props) =>
    Boolean(props.margin) &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    Boolean(props.sectionMargin) &&
    css`
      margin-top: ${props.sectionMargin}px;
      margin-bottom: ${props.sectionMargin}px;
    `}

  ${(props) =>
    Boolean(props.sectionMargin) &&
    css`
      margin-top: ${props.sectionMargin}px;
      margin-bottom: ${props.sectionMargin}px;
    `}
  
  ${(props) =>
    Boolean(props.sectionPadding) &&
    css`
      padding-top: ${props.sectionPadding}px;
      padding-bottom: ${props.sectionPadding}px;
    `}

  ${(props) =>
    Boolean(props.insideForm) &&
    css`
      padding-right: 24px;
      padding-left: 24px;
    `}

  ${(props) =>
    Boolean(props.isInsideModal) &&
    css`
      background: transparent;
      padding: 36px 0 0;
      margin: 0;
      box-shadow: none;
    `}

  ${(props) =>
    Boolean(props.isBorder) &&
    !props.isInsideModal &&
    css`
      border: 1px solid ${props.textColor};
    `}


  ${(props) =>
    props.isFullWidth &&
    !props.isInsideModal &&
    css`
      ${fullWidthSection};
    `}

  ${(props) =>
    props.isFullWidth &&
    props.isInsideDashboard &&
    !props.isInsideModal &&
    css`
      @media (min-width: 992px) {
        margin-left: -12px;
        width: calc(100% + 24px);
      }
    `}

  ${(props) =>
    props.shadow === 'soft' &&
    css`
      ${shadowSoft};
    `}

  ${(props) =>
    props.shadow === 'hard' &&
    css`
      box-shadow: ${props.shadowColor} 8px 8px 0 0;
    `}

  ${(props) =>
    props.shadow === 'hard' &&
    props.sectionBorder === 'double' &&
    css`
      box-shadow:
        ${props.shadowColor} 8px 8px 0 0,
        ${props.sectionBorderColor} 8px 8px 0 2px;
    `}

  ${(props) =>
    props.sectionShape === 'square' &&
    css`
      border-radius: 0;
    `}
  ${(props) =>
    props.sectionBorder &&
    css`
      border: 2px solid ${props.sectionBorderColor};
    `}
`;

export const UserHeaderText = styled.div.attrs({
  className: 'ql-editor',
})`
  min-height: initial !important;
  padding: 0 26px;
  font-size: 15px;
  font-weight: normal;
  line-height: 21px;
  overflow: hidden;
  text-overflow: clip;
  transition: max-height 0.2s ease-out;
  word-wrap: break-word;
  font-family: ${(props) => props.font};
  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}

  img {
    width: 100% !important;
    height: auto;
    border-radius: 3px;
  }

  h1,
  h2 {
    line-height: 1.1;
    font-weight: normal;
  }

  ${(props) =>
    props.isBiographyTrim &&
    css`
      overflow: hidden !important;
      max-height: ${props.biographyTrimCount}px;
    `}

  ${(props) =>
    props.isExpand &&
    css`
      overflow: initial !important;
      max-height: ${props.heightUserText}px;
    `}


  ${(props) =>
    props.customForm &&
    css`
      text-align: center;
      font-size: 18px;
      font-weight: bold;
    `}

  ${(props) =>
    props.isInsideModal &&
    css`
      color: #fff;
      padding: 0;
    `}

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${(props) =>
    props.insideModal &&
    css`
      margin-top: 50px;
      font-size: 18px;
    `}
`;

export const MediaHero = styled(Box)`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin: 0 auto;
  width: 100%;
  max-width: 768px;
  border-radius: 10px;
  height: 400px;
  object-fit: cover;

  @media (max-width: 568px) {
    height: 300px;
  }

  ${(props) =>
    props.backgroundImage &&
    css`
      background: url(${props.backgroundImage}) 50% 50% / cover;
    `}
`;

export const BioButtonBox = styled(Box)`
  display: flex;
  justify-content: center;
  margin-top: 16px;
  overflow: hidden;

  @media (min-width: 992px) {
    display: flex;
    justify-content: center;
  }

  ${(props) =>
    props.isContacts &&
    css`
      @media (min-width: 992px) {
        display: block;
      }
    `}
  ${(props) =>
    props.isText &&
    !props.isInsideDashboard &&
    css`
      width: 80px;
      margin: 16px auto 0;

      @media (min-width: 992px) {
        width: 380px;
        margin: 16px auto 0;
      }
    `}
       ${(props) =>
    props.buttonShape === 'square' &&
    css`
      border-radius: 8px !important;

      &:hover {
        border-radius: 8px !important;
      }
    `}
    
      ${(props) =>
    props.buttonShape === 'round' &&
    css`
      border-radius: 36px !important;

      &:hover {
        border-radius: 36px !important;
      }
    `}

    ${(props) =>
    props.buttonBorder === 'solid' &&
    css`
      border: 2px solid ${props.borderColor} !important;

      &:hover {
        border: 2px solid ${props.borderColor} !important;
      }
    `}
    ${(props) =>
    props.buttonBorder === 'none' &&
    css`
      border: none !important;
      outline: none !important;
    `}

      ${(props) =>
    props.buttonShadow === 'hard' &&
    css`
      box-shadow: ${props.buttonShadowColor} 8px 8px 0 0;
    `}
      ${(props) =>
    props.buttonShadow === 'soft' &&
    css`
      ${shadowSoft};
    `}
  
      ${(props) =>
    props.buttonShadow === 'hard' &&
    props.buttonBorder === 'double' &&
    css`
      box-shadow:
        ${props.buttonShadowColor} 8px 8px 0 0,
        ${props.borderColor} 8px 8px 0 2px;
      border: 2px solid ${props.borderColor} !important;
    `}
`;

export const MediaHeroImageBox = styled(Box)`
  width: 100%;
  height: 450px;

  @media (max-width: 768px) {
    display: none;
  }

  ${({ isInsideDashboard }) =>
    isInsideDashboard &&
    css`
      height: 660px;
    `};
`;

export const MediaHeroImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const MediaHeroContentWrapper = styled(Box)`
  width: 100%;
  height: 100%;
  display: grid;
  align-self: center;
  padding: 0 48px;

  ${(props) =>
    props.popupWelcome &&
    css`
      @media (max-width: 768px) {
        height: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 10vh;
      }
    `}
  ${(props) =>
    props.isInsideDashboard &&
    css`
      margin-top: -560px;
    `}

  ${(props) =>
    props.popupCategory &&
    css`
      @media (max-width: 768px) {
        height: 50%;
        display: flex;
        flex-direction: column;
        flex: none;
      }

      @media (min-width: 768px) {
        margin-top: 0;
        padding: 0;
        width: 100%;
        height: 50%;
        min-height: 450px;
        display: flex;
        flex-direction: column;
        flex: none;
      }
    `}

  ${(props) =>
    props.cover &&
    css`
      background: url(${props.cover});
      background-size: cover;
    `}
}
`;

export const MediaHeroContent = styled(Box)`
  position: relative;
  margin: 0 auto 12px auto;
  max-width: 216px;
  width: 100%;
  overflow: hidden;
  color: #000;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  border-bottom: 15px solid transparent;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${(props) =>
    props.popupHero &&
    css`
      position: static;
      margin: 0 auto 25px;
      transform: none;
      padding: 10px 12px 0 12px;
      border-bottom: 12px solid transparent;
      background: rgba(255, 255, 255, 0.7);
      cursor: default;

      @media (max-width: 768px) {
        width: 89%;
      }

      @media (min-width: 768px) {
        margin-right: 0;
        margin-left: 0;
        padding-right: 0;
        padding-left: 0;
      }
    `}

  ${(props) =>
    props.popupWelcome &&
    css`
      position: static;
      max-height: initial;
      //max-height: 122px;
      margin: 0;
      transform: none;
      border-bottom: none;
      background: transparent;
      color: #fff;
      font-size: 16px;
      cursor: default;

      @media (max-width: 768px) {
        width: 70%;
        max-height: initial;
      }

      @media (min-width: 768px) {
        color: #000;
      }
    `}

  ${(props) =>
    props.popupCategory &&
    css`
      padding: 30px 0 0 18px;

      @media (min-width: 768px) {
        color: #fff;
      }
    `}

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}

  ${(props) =>
    props.onlyButton &&
    css`
      background: transparent;
      padding: 0;
      width: 94%;
      border: none;

      @media (max-width: 768px) {
        width: 100%;
      }
    `}
`;

export const MediaHeroTitle = styled(Box)`
  max-height: 21px;
  overflow: hidden;
  font-size: 15px;
  font-weight: bold;

  ${(props) =>
    props.isTwoLine &&
    css`
      font-size: 22px;
      font-weight: bold;
      line-height: 25px;
      max-height: 50px;
    `}

  ${(props) =>
    props.popupWelcome &&
    css`
      font-size: 26px;
      font-weight: bold;
      line-height: 26px;
      //max-height: 50px;
      text-transform: uppercase;
      margin-bottom: 10px;
      max-height: initial;
    `}

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}
`;

export const MediaHeroDescription = styled(Box)`
  font-size: 15px;

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}

  ${(props) =>
    props.popupWelcome &&
    css`
      font-size: 22px;
      max-height: 300px;
    `}
`;

export const MediaHeroArrow = styled(Box)`
  position: absolute;
  top: 50%;
  right: 15px;
  margin-top: -8px;
  height: 30px;

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}
`;

export const InputBlock = styled.input`
  display: block;
  width: 100%;
  min-width: auto;
  margin-bottom: 15px;

  border: 1px solid #e0e2e9;
  border-radius: 8px;
  padding: 15px 16px;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.4px;
  color: #191d3a;
  outline: none;
  transition: all 0.2s;

  //&:focus {
  //  border-color: #a05f83;
  //}

  ${(props) =>
    props.borderColor &&
    css`
      &:focus {
        border-color: ${props.borderColor === '#ffffff' ? '#ccc' : props.borderColor};
      }
    `}

  ${(props) =>
    props.isEqualPaddings &&
    css`
      margin-top: 15px;
    `}
 
  ${(props) =>
    props.marginBottom &&
    css`
      margin-bottom: ${props.marginBottom};
    `}

  ${(props) =>
    props.insideButton &&
    css`
      border-radius: 30px;
      padding-right: 21.1%;
    `}
  
  ${(props) =>
    Boolean(props.btnOpacity) &&
    css`
      background: rgba(255, 255, 255, 0 ${props.btnOpacity});
      border-color: ${props.bgColor === '#ffffff' ? '#e0e2e9' : `rgba(255, 255, 255, 0.${props.btnOpacity})`};
    `}

  ${(props) =>
    props.customForm &&
    css`
      padding: 5px 15px;
      border-radius: 3px;
      line-height: 40px;
    `}


  ${(props) =>
    props.emailModal &&
    css`
      // color: #fff;
      border-radius: 50px;
      border: none;

      &::placeholder {
        color: #cbcbcb;
        opacity: 1; /* Firefox */
      }
    `}

  ${(props) =>
    Boolean(props.donationModal) &&
    css`
      max-width: 40px;
      height: 40px;
      margin: 0;
      padding: 5px;
      text-align: center;

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      &::placeholder {
        color: #fff;
        opacity: 1; /* Firefox */
      }
    `}

  ${(props) =>
    Boolean(props.donationModal) &&
    props.isInsideDashboard &&
    css`
      width: 32px;
      height: 32px;
    `}

  ${(props) =>
    Boolean(props.isWhiteBG) &&
    css`
      color: #000;
      box-shadow: 0 4px 8px rgb(121 121 121 / 37%);
    `}

  ${(props) =>
    props.emailCardInput &&
    css`
      border-radius: 6px;
      padding: 15px;
    `}

  ${(props) =>
    props.isButtonRadius &&
    css`
      border-radius: 36px !important;
    `}

  ${(props) =>
    props.search &&
    css`
      height: 36px;
      box-shadow: none;
      border: none;
      border-radius: 50%;
    `}

  ${(props) =>
    props.background &&
    css`
      background: ${props.background};
    `}

  ${(props) =>
    props.donationItems &&
    css`
      font-size: 36px;
      width: 100%;
      min-width: initial;
      max-width: initial;
      text-align: center;
      border: none;
      outline: none;
      box-shadow: none;
      position: relative;
      z-index: 100;
      background: transparent;
      color: transparent;
    `}

  ${(props) =>
    props.isCardInput &&
    css`
      border: 1px solid rgb(224, 226, 233);
      box-shadow: none;
    `}

  ${(props) =>
    props.isTelegram &&
    css`
      padding: 16px 16px;
    `}
  ${(props) =>
    props.isWhatsApp &&
    css`
      padding: 16px 16px;
    `}
    ${({ shape }) =>
    shape === 'square' &&
    css`
      border-radius: 8px !important;
      &:hover {
        border-radius: 8px !important;
      }
    `}
  
    ${({ shape }) =>
    shape === 'round' &&
    css`
      border-radius: 36px !important;

      &:hover {
        border-radius: 36px !important;
      }
    `}
`;

export const InputErrorBox = styled(Box)`
  display: none;

  color: red;
  margin-bottom: 8px;
  margin-top: -8px;

  ${(props) =>
    props.isShowing &&
    css`
      display: block;
    `}
`;

export const UserHeaderEmail = styled(Box)`
  // min-height: 200px;
  margin: ${mainIndent} 0;
  width: 100%;
  padding: 20px 12px;
  border-radius: 8px;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    Boolean(props.sectionMargin) &&
    css`
      margin-top: ${props.sectionMargin}px;
      margin-bottom: ${props.sectionMargin}px;
    `}
  
  ${(props) =>
    Boolean(props.sectionPadding) &&
    css`
      padding-top: ${props.sectionPadding}px;
      padding-bottom: ${props.sectionPadding}px;
    `}
  
   ${(props) =>
    props.bgColor &&
    css`
      background: ${props.bgColor};
    `}

  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}
   

  ${(props) =>
    props.isBorder &&
    css`
      border: 1px solid ${props.textColor};
    `}



   ${(props) =>
    props.isFullWidth &&
    css`
      ${fullWidthSection};
    `}

   ${(props) =>
    props.isFullWidth &&
    props.isInsideDashboard &&
    css`
      pointer-events: none;
      padding-left: 32px;
      padding-right: 32px;
    `}


   ${(props) =>
    props.shadow === 'soft' &&
    css`
      ${shadowSoft};
    `}

  ${(props) =>
    props.shadow === 'hard' &&
    css`
      ${shadowHard};
    `}
`;

export const UserHeaderEmailHeading = styled(Box)`
  text-align: center;

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${(props) =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}
`;

export const UserHeaderEmailTitle = styled(Box)`
  font-size: 20px;
  font-weight: bold;
`;

export const UserHeaderEmailText = styled(Box)`
  margin: 10px 0 15px;
`;

export const SectionHeading = styled(Box)`
  text-align: center;

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  ${(props) =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}

  ${(props) =>
    props.paddingTop &&
    css`
      padding-top: ${props.paddingTop};
    `}

  ${(props) =>
    props.isInside &&
    css`
      padding-right: 12px;
      padding-left: 12px;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const SectionTitle = styled(Box)`
  font-size: 22px;
  font-weight: bold;
  word-wrap: break-word;

  ${(props) =>
    props.isPaddingTop &&
    css`
      padding-top: 12px;
    `}
  ${(props) =>
    props.isMarginTop &&
    css`
      margin-top: 12px;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${(props) =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}
  ${(props) => props.isMap && css``}
`;

export const SectionText = styled(Box)`
  font-size: 18px;
  margin: 10px 0 15px;
  word-wrap: break-word;

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}
  ${(props) =>
    props.bold &&
    css`
      font-weight: bold;
    `}
  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const SectionImageBox = styled(Box)`
  margin: 10px 0 12px;
`;

export const SectionImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
`;

export const UserHeaderEmailBox = styled(Box)`
  position: relative;
`;

export const EmailButtonText = styled(Box)`
  padding-left: 5px;
  //max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;

  ${(props) =>
    props.bold &&
    css`
      font-weight: bold;
    `}

  ${(props) =>
    props.insideModal &&
    css`
      max-width: none;
      white-space: pre-wrap;
    `}

  ${(props) =>
    props.isInsideHighlight &&
    css`
      max-width: none;
      white-space: normal;
    `}

  ${(props) =>
    props.isSubmitOrder &&
    css`
      padding: 0;
    `}
`;

export const UserHeaderEmailResponse = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${mainIndent} 0;
  height: 115px;
  width: 100%;
  text-align: center;

  ${(props) =>
    props.emailModal &&
    css`
      color: #000;
      height: 135px;
    `}

  ${(props) =>
    props.isForm &&
    css`
      flex-direction: column;
      gap: 16px;
      color: #000;
      height: 250px;
      max-width: unset;
    `}

  ${(props) =>
    props.thanksMessage &&
    css`
      min-height: 200px;
      height: initial;
      display: flex;
      flex-direction: column;
    `}
`;

export const UserButtonLinks = styled(Box)`
  margin: 2px 0;
  display: flex;
  flex-direction: column;

  ${(props) =>
    props.isBottom &&
    css`
      margin-top: auto;
    `}
`;

// background: linear-gradient(-180deg, rgba(108,106,106,0) 0%, rgba(0,0,0,0.6) 100%);

export const UserContactList = styled(Box)`
  position: fixed;
  display: flex;
  margin: 0 auto;
  backdrop-filter: none;
  transition: all 0.25s;
  bottom: 0;
  right: 0;
  z-index: 100;
  width: 100%;
  max-width: 680px;
  padding: 20px 1px 5px 11px;
  left: -17px;

  @media (max-width: 768px) {
    left: 0;
    display: flex;
    position: fixed;
  }

  @media (min-width: 768px) {
    padding: 20px 21px 5px 31px;
  }

  ${(props) =>
    props.isInsideDashboard &&
    css`
      left: 0;
      display: flex;
      position: fixed;

      @media (min-width: 768px) {
        padding: 20px 1px 5px 11px;
      }
    `}

  ${(props) =>
    props.alignLeft &&
    css`
      justify-content: flex-end;
    `}

  ${(props) =>
    props.viewPost &&
    css`
      z-index: 0 !important;
    `}
  
  ${(props) =>
    props.insideBio &&
    css`
      position: static;
      background: transparent;
      padding: 20px 0 10px 0;

      @media (max-width: 768px) {
        position: static;
      }

      ${(props) =>
        props.isInsideDashboard &&
        css`
          position: static;
        `}
    `}


  ${(props) =>
    props.directMessage &&
    css`
      position: static;
      background: transparent;
      padding: 20px 0 10px 0;

      display: flex;
      flex-direction: column;

      @media (max-width: 768px) {
        position: static;
      }

      ${(props) =>
        props.isInsideDashboard &&
        css`
          position: static;
        `}
    `}

  ${(props) =>
    props.directMessage &&
    props.isInsideDashboard &&
    css`
      position: static;
    `}
  
  ${(props) =>
    props.hide &&
    css`
      visibility: visible;
      opacity: 0;
      margin-bottom: -20%;
      transition: all 0.25s;
    `}
  
  ${(props) =>
    props.scrollbarWidth &&
    css`
      left: -${props.scrollbarWidth}px;
    `}

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  ${(props) =>
    props.isActiveButton &&
    css`
      padding: 0 !important;
      margin: 0 !important;
    `}

  ${(props) =>
    props.isList &&
    css`
      margin-top: 12px !important;
    `}
`;

export const VideoControlsBox = styled(Box)`
  margin: 0 auto;
  min-width: 0;
  position: fixed;
  top: 70px;
  left: 12px;
  z-index: 91;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.4);

  @media (min-width: 768px) {
    right: 0;
    left: 0;
    width: 162px;
  }

  ${(props) =>
    props.isPromoBar &&
    css`
      position: absolute;
      top: 117px;
    `}

  ${(props) =>
    props.isNotHeader &&
    css`
      top: 24px;
    `}

  ${(props) =>
    props.isPromoBar &&
    props.isNotHeader &&
    css`
      top: 69px;
    `}
`;

export const VideoControlsList = styled(Box)`
  display: flex;
  padding: 7px 10px;
  width: auto;
  justify-content: space-around;
`;

export const VideoControlsItem = styled(Box)`
  display: flex;
  align-items: center;
`;

export const VideoControlsIcon = styled.img`
  width: 20px;
  height: 20px;

  ${(props) =>
    props.animate &&
    css`
      transition: 1s;
    `}
`;

export const VideoControlsTitle = styled(Box)`
  display: none;
  font-size: 14px;
  font-weight: bold;
  margin-left: 5px;
  text-transform: uppercase;
  color: #fff;

  ${(props) =>
    props.isShowing &&
    css`
      display: block;
    `}
`;

export const WelcomeMessageBox = styled(Box)`
  display: none;
  margin: 0 auto;
  min-width: 0;
  position: fixed;
  bottom: 82px;
  z-index: 91;
  right: 50%;
  transform: translateX(50%);

  max-width: 390px;
  padding: 25px 40px;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.16) 0 5px 40px;

  ${(props) => props.isInsideDashboard && css``}

  ${(props) =>
    props.show &&
    css`
      display: block;
    `}

  img {
    width: 188px !important;
    height: auto !important;
  }

  ${(props) =>
    props.isBottom &&
    css`
      bottom: 20px;
    `}

  ${(props) =>
    props.shape === 'square' &&
    css`
      border-radius: 2px;
    `}
  
    ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  
    ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}
  
    ${(props) =>
    props.background &&
    css`
      background: ${props.background};
    `}
  
    ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}
    ${(props) =>
    props.banner &&
    css`
      padding: 20px 0;
    `}
  
    ${(props) =>
    props.isBorder &&
    css`
      border: 1px solid ${props.color};
    `}
    ${(props) =>
    props.sectionBorder === 'solid' &&
    css`
      border: 2px solid ${props.sectionBorderColor};
    `}
  
    ${(props) =>
    props.borderStyle &&
    css`
      border: ${props.borderStyle};
    `}
  
    ${(props) =>
    props.isFullWidth &&
    css`
      ${fullWidthSection};
    `}
  
    ${(props) =>
    props.isFullWidth &&
    props.isInsideDashboard &&
    css`
      padding-left: 32px;
      padding-right: 32px;
    `}
  
      ${(props) =>
    props.isInsideDashboard &&
    css`
      pointer-events: none;
    `}
  
      ${(props) =>
    props.shadow === 'soft' &&
    css`
      ${shadowSoft};
    `}
  
    ${(props) =>
    props.shadow === 'hard' &&
    css`
      box-shadow: ${props.shadowColor} 8px 8px 0 0;
    `}
  
    ${(props) =>
    props.shadow === 'hard' &&
    props.sectionBorder === 'double' &&
    css`
      box-shadow:
        ${props.shadowColor} 8px 8px 0 0,
        ${props.sectionBorderColor} 8px 8px 0 2px;
      border: 2px solid ${props.sectionBorderColor};
    `}
  
    ${(props) =>
    props.sectionShadow &&
    css`
      box-shadow: ${props.sectionShadow};
    `}
  
  
    ${(props) =>
    props.sectionMargin &&
    css`
      margin-top: ${props.sectionMargin}px;
      margin-bottom: ${props.sectionMargin}px;
    `}
  
    ${(props) =>
    props.sectionPadding &&
    css`
      padding-top: ${props.sectionPadding}px;
      padding-bottom: ${props.sectionPadding}px;
    `}
`;

export const WelcomeMessageClose = styled.a`
  position: absolute;
  right: 12px;
  top: 12px;
  width: 16px;
  height: 16px;
  opacity: 0.3;

  cursor: pointer;

  //outline: 1px solid indianred;

  &:hover {
    opacity: 1;
  }
  &:before,
  &:after {
    position: absolute;
    left: 7px;
    content: ' ';
    height: 17px;
    width: 2px;
    background-color: #333;
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
`;

export const Alert = styled.div`
  text-align: center;
  margin-top: 36px;
  ${({ isContactsModal }) =>
    isContactsModal &&
    css`
      margin-top: 0;
    `}
`;

export const GapWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 12px;
`;

export const UserContactItemLink = styled.button`
  position: relative;

  cursor: pointer;
  padding: 4px 10px;
  flex-basis: 50%;
  margin-right: 10px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 14px;
  text-decoration: none;
  outline: none;
  border: none;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  ${(props) =>
    props.isInsideDashboard &&
    css`
      margin-right: 0;
    `}
  ${(props) =>
    props.contacts &&
    css`
      margin-right: 0;
      width: 100%;
    `}
  ${(props) =>
    props.noOutline &&
    css`
      border: none;
      outline: none;
    `}

  ${(props) =>
    props.background &&
    css`
      background: ${props.background};
    `}
  
  &:only-child {
    flex-basis: 100%;
  }

  ${(props) =>
    props.column &&
    css`
      flex-direction: column;
    `}

  ${(props) =>
    props.center &&
    css`
      justify-content: center;
      align-items: center;
    `}

 ${(props) =>
    props.insideBio &&
    css`
      &:last-child {
        margin-right: 0;
      }
    `}
 
 ${(props) =>
    props.directMessage &&
    css`
      position: relative;
      text-align: center;

      flex: none;
      margin-right: 0;
      margin-bottom: 20px;
      min-height: 44px;
      border-radius: 8px;
      font-size: 18px;
      letter-spacing: 0.8px;
    `}

 ${(props) =>
    props.circleDesign &&
    css`
      position: absolute;
      top: -50px;
      border-radius: 50%;
      width: 60px;
      height: 60px;
      flex-basis: auto;

      &:only-child {
        flex-basis: auto;
      }
    `}

 ${(props) =>
    props.animate &&
    css`
      animation: 5s ${keyframes`
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(${props.rgb?.r}, ${props.rgb?.g}, ${props.rgb?.b}, 0.7);
    }
  
    70% {
      transform: scale(1);
      box-shadow: 0 0 0 10px rgba(${props.rgb?.r}, ${props.rgb?.g}, ${props.rgb?.b}, 0);
    }
  
    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(${props.rgb?.r}, ${props.rgb?.g}, ${props.rgb?.b}, 0);
    }`};
      animation-iteration-count: infinite;
    `}

${(props) =>
    props.animateShow &&
    css`
      transition: top 0.35s;
      top: 0;
    `}
 
 ${(props) =>
    props.top &&
    css`
      top: -${props.top}px;
    `}

 ${(props) =>
    props.chat &&
    css`
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.11);
    `}


 ${(props) =>
    props.insideBio &&
    css`
      display: flex;
    `}

 ${(props) =>
    props.isButton &&
    css`
      position: static;
      margin-right: 0;
    `}

 ${(props) =>
    props.isSubscribe &&
    css`
      margin: 5px 0;
      border-radius: 50px;
      height: 54px;
      max-height: 54px;
      min-height: 54px;
      width: 100%;
      outline: none;
      border: none;
      font-size: 16px;
      padding-left: 5px;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: bold;
      max-width: none;
      white-space: pre-wrap;
    `}

 ${(props) =>
    props.isCompact &&
    css`
      position: absolute;
      top: 0;
      right: 0;
      max-width: 20%;

      margin: 0;
      padding: 0;
      margin-top: 2px;
      margin-right: 2px;
      height: 54px;
      max-height: 54px;
      min-height: 54px;
      min-width: 41%;

      span {
        font-size: 14px;
        margin-left: -15px;
      }
    `}

    ${(props) =>
    props.shape === 'square' &&
    css`
      border-radius: 8px !important;

      &:hover {
        border-radius: 8px !important;
      }
    `}
  
    ${(props) =>
    props.shape === 'round' &&
    css`
      border-radius: 36px !important;

      &:hover {
        border-radius: 36px !important;
      }
    `}

      ${(props) =>
    props.border === 'solid' &&
    css`
      border: 2px solid ${props.borderColor} !important;

      &:hover {
        border: 2px solid ${props.borderColor} !important;
      }
    `}
      ${(props) =>
    props.border === 'none' &&
    css`
      border: none !important;
      outline: none !important;
    `}
  
        ${(props) =>
    props.shadow === 'hard' &&
    css`
      box-shadow: ${props.shadowColor} 8px 8px 0 0;
    `}
        ${(props) =>
    props.shadow === 'soft' &&
    css`
      ${shadowSoft};
    `}
    
        ${(props) =>
    props.shadow === 'hard' &&
    props.border === 'double' &&
    css`
      box-shadow:
        ${props.shadowColor} 8px 8px 0 0,
        ${props.borderColor} 8px 8px 0 2px;
      border: 2px solid ${props.borderColor} !important;
    `}
`;

export const UserContactIcon = styled.img`
  width: 35px;
  height: 35px;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.preview &&
    css`
      width: 25px;
      height: 25px;
    `}

  ${(props) =>
    props.directMessage &&
    css`
      position: absolute;
      top: 5px;
      left: 15px;
    `}
`;

export const UserContactIconSVG = styled.img`
  width: 25px;
  height: 25px;
`;

export const UserContactClose = styled.span`
  width: 32px;
  height: 32px;

  &:hover {
    opacity: 1;
  }
  &:before,
  &:after {
    position: absolute;
    left: 0;
    content: ' ';
    height: 20px;
    width: 2px;
    background-color: #000;
    right: 0;
    margin: auto;
    top: 0;
    bottom: 0;
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
`;

export const UserContactTitle = styled.span`
  color: #fff;

  ${(props) =>
    props.isButton &&
    css`
      width: 100%;
      text-align: center;
      margin-left: -35px;
      margin-right: 10px;
    `}
  ${(props) =>
    props.contacts &&
    css`
      display: flex;
      flex-direction: column;
    `}
`;

export const UserContactData = styled.span`
  width: 100%;
  word-wrap: break-word;
  padding-left: 44px;
  padding-right: 44px;
`;

export const BackgroundVideoBox = styled.video`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  object-fit: cover;
`;
/*
export const ScrollWrapperBox = styled(Box)`

  ${props => props.fixed && css`
    position: fixed;
    top: 0;

    overflow: hidden;
    width: 680px;
    z-index: 100;
    background: #fff;
    padding: 10px 20px;
    margin-left: -32px;
    box-shadow: rgb(0 0 0 / 15%) 0 5px 15px 0;

    @media (max-width: 568px) {
      padding: 10px 30px;
    }
 `}
`;
*/
export let PhotoListEmpty = styled(Flex)`
  margin: 50px;
  font-weight: bold;
  text-align: center;
  justify-content: center;
`;

// tiktok
export let TikTokBox = styled(Flex)`
  .slick-slide {
    //margin-right: 15px !important;
  }
`;

export let TikTokList = styled(Flex)`
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 10px;
  margin-bottom: 40px;

  @media (max-width: 797px) {
    margin-bottom: 25px;
  }
`;

export let ShopTitle = styled(Flex)`
  margin: 0 auto;
  padding: 20px 30px;
  font-size: 28px;
  line-height: 1.3;
  font-weight: bold;
  text-align: center;

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}
`;

export let ScrollWrapperBox = styled(Box)``;

// categoreis
export let CategoriesList = styled(Flex)`
  //margin-top: -20px;
  margin-bottom: 20px;
`;

export let CategoriesItem = styled(Box)`
  min-width: 124px;
  height: 40px;
  display: flex;
  align-items: center;
  //text-transform: uppercase;
  padding: 0;
  margin: 0;
  cursor: pointer;
  background: #fff;
  border: 1px solid #e0e2e9;
  border-radius: 32px;

  @media (max-width: 568px) {
    font-size: 14px;
  }

  ${(props) =>
    props.noIcon &&
    css`
      justify-content: center;
      text-align: center;
    `}

  ${(props) =>
    props.filter &&
    css`
      min-width: 40px;
    `}

  ${(props) =>
    props.search &&
    css`
      justify-content: flex-start;
    `}

  ${(props) =>
    props.isShowInput &&
    css`
      animation: 0.5s ${keyframes`
      0% {
        min-width: 40px;
      }
      
      100% {
        min-width: 300px;
      }`};

      animation-timing-function: ease-in-out;
      animation-fill-mode: forwards;
    `}

  ${(props) =>
    props.isHideInput &&
    css`
      animation: 0.5s ${keyframes`
      0% {
        min-width: 300px;
      }
      
      100% {
        min-width: 40px;
      }`};

      animation-timing-function: ease-in-out;
      animation-fill-mode: forwards;
    `}
`;

export let CategoriesItemIcon = styled.img`
  padding: 0;
  margin: 1px 5px 1px 1px;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  overflow: hidden;

  ${(props) =>
    props.filter &&
    css`
      height: 28px;
      width: 28px;
    `}

  ${(props) =>
    props.search &&
    css`
      margin-left: 5px;
    `}
`;

export let CategoriesItemText = styled.span`
  margin: 0 20px;
  color: #000;

  ${(props) =>
    props.active &&
    css`
      position: relative;
      font-weight: bold;

      // &:after {
      //   content: '';
      //   position: absolute;
      //   bottom: -3px;
      //   left: 0;
      //   width: 100%;
      //   height: 2.3px;
      //   background: ${props.textColor};
      // }
    `}
`;

export let ArrowBox = styled.div`
  cursor: pointer;
  position: absolute;
  margin-top: -11px;

  display: none;

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  ${(props) =>
    props.prev &&
    css`
      left: 12px;

      @media (min-width: 768px) {
        left: 77px;
      }
    `}

  ${(props) =>
    props.next &&
    css`
      right: 12px;

      @media (min-width: 768px) {
        right: 77px;
      }
    `}
`;

export const TikTokImgBox = styled(Box)`
  position: relative;
  display: block;
  margin-bottom: 2%;
  width: calc(50% - 8px);
  height: auto;
  border-radius: 16px;
  cursor: pointer;
  //height: 529px;

  @media (max-width: 797px) {
    //height: 316px;
    width: calc(50% - 4px);
    margin-bottom: 30px;
  }

  ${(props) =>
    props.heightTikTok &&
    css`
      @media (max-width: 768px) {
        height: ${props.heightTikTok}px !important;
      }
    `}

  ${(props) =>
    props.fourthView &&
    css`
      width: calc(100% - 8px);

      @media (min-width: 768px) {
        width: calc(100% - 4px);
      }

      @media (max-width: 797px) {
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 30px;
        width: 80%;
        height: ${props.heightTikTokVideoFourthView}px !important;
      }
    `}

  ${(props) =>
    props.slider &&
    props.layout === 7 &&
    css`
      width: 180px;
      display: flex;
      justify-content: center;

      @media (max-width: 768px) {
        width: 180px;
        margin: 0;
        height: ${props.heightTikTok}px !important;
      }
    `}

  ${(props) =>
    props.slider &&
    props.layout === 4 &&
    css`
      width: 300px;
      display: flex;
      justify-content: center;

      @media (max-width: 768px) {
        width: 300px;
        margin: 0;
        height: ${props.heightTikTokVideoFourthView}px !important;
      }
    `}
`;

export const TikTokImg = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 16px;

  ${(props) =>
    props.icon &&
    css`
      position: absolute;
      bottom: 10px;
      margin-left: -5px;
      left: 10px;
      width: 30px;
      height: 25px;
    `}
`;

export const TikTokIcon = styled.img`
  position: absolute;
  bottom: 10px;
  left: 10px;
  width: 25px;
  height: 25px;
`;

export const AddToBasketIcon = styled.svg`
  width: 25px;
  height: 25px;

  ${(props) =>
    props.size &&
    css`
      margin-right: -15px;
      width: ${props.size};
      height: ${props.size};
    `}
`;

export const AddToBasketIconBox = styled(Box)`
  width: 25px;
  height: 25px;

  ${(props) =>
    props.size &&
    css`
      margin-right: -15px;
      width: ${props.size};
      height: ${props.size};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const PhotoOverlay = styled(Box)`
  display: none;

  ${PhotoBox}:hover & {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 10px;
    background-color: rgba(0, 0, 0, 0.3);
    cursor: pointer;
    color: white;

    ${(props) =>
      props.shape === 'round' &&
      css`
        border-radius: 32px;
      `}
  }
`;

export const PostImageBox = styled(Box)`
  position: relative;
  width: 100%;
  height: 100%;

  ${(props) =>
    props.imageView === 'square' &&
    css`
      padding: 20px;
    `}

  ${(props) =>
    props.insideGalley &&
    css`
      height: 560px !important;
    `}
  ${(props) =>
    props.isPointer &&
    css`
      cursor: pointer;
    `}

  ${(props) =>
    props.mobileBox &&
    css`
      height: 350px !important;
    `}

  ${(props) =>
    props.isSmall &&
    css`
      margin: 2px 0;
      border-radius: 8px;
      padding-right: 10px;
      width: 80px !important;
      height: 80px !important;
    `}

  ${(props) =>
    props.active &&
    css`
      outline: 2px solid #000000;
    `}

  ${(props) =>
    props.isFirstSlide &&
    css`
      margin-left: 2px;
    `}

  ${(props) =>
    props.layout === 6 &&
    css`
      width: 50%;
      flex-shrink: 0;
    `}
  ${(props) =>
    props.postLayout === 0 &&
    css`
      width: 100%;
    `}
    ${(props) =>
    props.layout === 7 &&
    css`
      height: 280px;
    `}

  ${(props) =>
    props.viewItem &&
    css`
      height: initial;
    `}
`;

export const PostImageBoxModal = styled(Box)`
  flex: none;
  position: relative;
  height: auto;
  overflow: hidden;

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.height &&
    css`
      height: ${props.height};
    `}

  ${(props) =>
    props.maxWidth &&
    css`
      max-width: ${props.maxWidth};
    `}

  ${(props) =>
    props.maxHeight &&
    css`
      max-height: ${props.maxHeight};
    `}
`;

export const PostTikTokVideoBoxModal = styled(Box)`
  width: 310px;
  height: 520px;
  position: relative;
  padding: 20px;
  overflow: hidden;

  @media (max-width: 568px) {
    padding: 0;
    width: 100%;
    height: 100%;
    flex: none;
  }

  ${(props) =>
    props.isInsideDashboard &&
    css`
      padding: 0;
      width: 170px;
      height: 302px;
      flex: none;
    `}

  ${(props) =>
    props.insideList &&
    css`
      padding: 0;
      //width: 300px;
      //height: 529px;
      margin-bottom: 2%;
      width: calc(50% - 8px);

      //height: auto !important;
      //height: calc((100vw - 2px) / 0.485714);
      border-radius: 16px;

      @media (min-width: 768px) {
        min-height: 580px;
      }

      @media (max-width: 568px) {
        width: calc(50% - 4px);
        margin-bottom: 30px;
        //height: 316px;
      }

      ${(props) =>
        props.isInsideDashboard &&
        css`
          width: calc(50% - 4px);
          margin-bottom: 0;
          min-height: initial !important;
        `}
    `}
  
  ${(props) =>
    props.fixed &&
    css`
      position: fixed;
      top: 0;
      left: 0;
      width: 100% !important;
      height: 100% !important;
      background: #fff;
      z-index: 1000;
    `}
  
  ${(props) =>
    props.heightTikTok &&
    css`
      @media (max-width: 768px) {
        height: ${props.heightTikTok}px !important;
      }

      ${(props) =>
        props.isInsideDashboard &&
        css`
          height: 265px;
        `}
    `}
  
  ${(props) =>
    props.fourthView &&
    css`
      width: 100%;
      display: flex;
      justify-content: center;

      @media (max-width: 768px) {
        width: 80%;
        margin: 0 auto 30px auto;
        height: ${props.heightTikTokVideoFourthView}px !important;
      }

      ${(props) =>
        props.isInsideDashboard &&
        css`
          width: 100%;
          margin: 0 auto 30px auto;
          height: 544px;
        `}
    `}

  ${(props) =>
    props.slider &&
    props.layout === 7 &&
    css`
      width: 180px;
      display: flex;
      justify-content: center;

      @media (max-width: 768px) {
        width: 180px;
        margin: 0;
        height: ${props.heightTikTok}px !important;
      }
    `}

  ${(props) =>
    props.slider &&
    props.layout === 4 &&
    css`
      width: 300px;
      display: flex;
      justify-content: center;

      @media (max-width: 768px) {
        width: 300px;
        margin: 0;
        height: ${props.heightTikTokVideoFourthView}px !important;
      }
    `}
`;

export const PostTikTokVideoModal = styled.iframe`
  width: 100%;
  height: 121%;

  ${(props) =>
    props.insideList &&
    css`
      @media (max-width: 768px) {
        height: 960px;
        margin-top: -2px;
        margin-left: -2px;
        width: 102%;
      }

      ${(props) =>
        props.isInsideDashboard &&
        css`
          height: 265px;
          margin-top: -2px;
          margin-left: -2px;
          width: 102%;
        `}
    `}

  ${(props) =>
    props.fourthView &&
    css`
      width: 54%;

      @media (max-width: 768px) {
        width: 102%;
        margin-top: -2px;
        margin-left: -2px;
      }

      ${(props) =>
        props.isInsideDashboard &&
        css`
          width: 102%;
          margin-top: -2px;
          margin-left: -2px;
          height: 544px;
        `}
    `}

  ${(props) =>
    props.sliderView &&
    css`
      width: 100%;

      @media (max-width: 768px) {
        width: 112%;
        margin-top: -2px;
        margin-left: -2px;
      }

      ${(props) =>
        props.isInsideDashboard &&
        css`
          width: 112%;
          margin-top: -2px;
          margin-left: -2px;
        `}
    `}
`;

export const PostContentBoxModal = styled(Box)`
  flex: none;
  padding: 20px;
  width: 450px;
  //max-height: 600px;
  overflow-y: auto;
  ${(props) =>
    props.height &&
    css`
      height: ${props.height};
    `}

  //overflow: overlay;
  
  &::-webkit-scrollbar {
    width: 0.7em;
    background: transparent;
  }

  ${(props) =>
    props.columnStyle &&
    css`
      flex: inherit;
      width: 350px;
      padding: 0 0 0 13px;
    `}

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding} !important;
    `}

  ${(props) =>
    props.tikTok &&
    css`
      @media (max-width: 568px) {
        height: auto !important;
        padding: 0 0 0 13px !important;
      }
    `}
`;

export const PostAction = styled(Box)`
  position: sticky;
  bottom: 0;
  z-index: 101;

  margin-bottom: 3px;
  width: 100%;

  &:last-child {
    margin-bottom: 0;
  }

  ${(props) =>
    props.insideLook &&
    css`
      position: static;
      margin-bottom: 25px;
    `}

  ${(props) =>
    props.googlePay &&
    css`
      div {
        width: 100% !important;

        button {
          border-radius: 18px !important;
        }
      }
    `}
`;

export const ViewPostWrapper = styled(Box)``;

export const ViewPostSimilar = styled(Box)`
  margin-top: 30px;
`;

export const ViewPostSimilarTitle = styled(Box)`
  font-size: 20px;
  line-height: 1.45;
  letter-spacing: 0.5px;
`;

export const ViewPostSimilarText = styled(Box)`
  margin-top: 50px;
  font-size: 16px;
  text-align: center;
  color: red;
`;

export const PostInfo = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 12px;

  ${(props) =>
    !props.isHidden &&
    css`
      display: none;
    `}
`;

export const PostTitle = styled(Box)`
  display: flex;
  justify-content: space-between;

  max-width: 100%;
  text-align: left;
  font-size: 20px;
  line-height: 1.45;
  letter-spacing: 0.5px;

  ${(props) =>
    !props.isZeroOldPrice &&
    !props.isZeroPrice &&
    css`
      max-width: 100%;
    `}

  ${(props) =>
    props.isNoTitle &&
    css`
      justify-content: flex-end;
    `}
`;

export const PostShareBox = styled(Box)`
  position: relative;
  top: 3px;
  cursor: pointer;
`;

export const PostShareImg = styled.img`
  width: 21px;
  height: 21px;
  margin-right: 7px;
`;

export const PostDescription = styled(Box)``;

export const PostPriceBox = styled(Box)`
  margin-top: 4px;
  display: flex;
  align-items: flex-end;
  font-size: 24px;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.isAppointmentPostActive &&
    css`
      align-items: center;
    `}
`;

export const PostTime = styled(Box)`
  margin-right: 15px;

  ${(props) =>
    props.$textColor &&
    css`
      color: ${props.$textColor};
    `}
`;

export const PostOldPrice = styled(Box)`
  color: #999;
  position: relative;
  letter-spacing: 0.5px;
  font-size: 18px;
  line-height: 23px;

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: -2px;

    width: 100%;
    height: 2px;
    margin-top: -2px;
    background: #999;
  }

  ${(props) =>
    !props.isZero &&
    css`
      display: none;
    `}
  ${(props) =>
    props.bold &&
    css`
      font-weight: bold;
    `}

  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};

      &:before {
        background: ${props.textColor};
      }
    `}

  ${(props) =>
    props.$textColor &&
    css`
      color: ${props.$textColor};

      &:before {
        background: ${props.$textColor};
      }
    `}
`;

export const ContentWrap = styled.div.attrs({
  className: 'ql-container ql-snow',
})`
  border: none !important;

  ${(props) =>
    props.isReview &&
    css`
      overflow: hidden;
      max-height: 192px;
    `}

  ${(props) =>
    props.isExpandText &&
    css`
      max-height: initial;
    `}
`;

export const Content = styled.div.attrs({
  className: 'ql-editor',
})`
  min-height: initial !important;
  border: none !important;

  padding: 0 !important;
  font-size: 16px;
  font-weight: normal;
  line-height: 21px;
  overflow: hidden;
  text-overflow: clip;
  transition: max-height 0.2s ease-out;
  word-wrap: break-word;

  img {
    width: 100% !important;
    height: auto;
    border-radius: 3px;
  }

  h1,
  h2 {
    line-height: 1.1;
    font-weight: normal;
  }

  ${(props) =>
    props.$textColor &&
    css`
      color: ${props.$textColor};
    `}
`;

export const ButtonImage = styled.img`
  width: 22px;
  height: 22px;
  margin-right: 15px;
`;

export const ButtonIcon = styled.img`
  width: 12px;
  height: 12px;
  margin-right: 15px;

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.height &&
    css`
      height: ${props.height};
    `}
`;

export const PostPrice = styled(Box)`
  margin-right: 10px;
  color: #000000;

  letter-spacing: 0.5px;
  font-size: 24px;
  line-height: 26px;

  ${(props) =>
    props.bold &&
    css`
      font-weight: bold;
    `}

  ${(props) =>
    !props.isZero &&
    css`
      display: none;
    `}

  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.$textColor &&
    css`
      color: ${props.$textColor};
    `}
`;

export const PostTextBox = styled(Box)`
  margin-top: 10px;
  margin-bottom: 25px;
  white-space: pre-line;

  font-size: 16px;
  line-height: 1.4;
  color: #8a8a8a;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  text-transform: none;

  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}

  ${(props) =>
    props.link &&
    css`
      color: #4e75fe;
    `}
`;

export const PostImg = styled.img`
  width: 100%;
  height: 100%;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;

  @media (max-width: 768px) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  ${(props) =>
    props.imageView === 'square' &&
    css`
      border-radius: 12px;
    `}

  ${(props) =>
    props.insideGalley &&
    css`
      height: 560px !important;
      object-fit: cover;
    `}

  ${(props) =>
    props.mobileBox &&
    css`
      object-fit: cover;
      height: 350px !important;
      border-radius: unset;
    `}

  ${(props) =>
    props.isPreview &&
    css`
      border-radius: 0;
    `}

  ${(props) =>
    props.isSmall &&
    css`
      border-radius: 8px;
      width: 80px !important;
      height: 80px !important;

      @media (max-width: 768px) {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
      }
    `}
`;

export const PostFooterBox = styled(Box)`
  padding: 15px 20px 50px 20px;

  ${(props) =>
    props.mobileViewPost &&
    css`
      border-radius: 20px;
      position: relative;
      top: 0;
      background: #fff;
    `}
`;

export const BackIconWrap = styled(Box)`
  position: relative;
  max-width: 935px;
  margin-left: auto;
  margin-right: auto;
  min-width: 100%;
  z-index: 102;
`;

export const BackIconBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 18px;
  left: 15px;
  cursor: pointer;
  border-radius: 50%;
  background: #fff;
  width: 45px;
  height: 45px;
  box-shadow: 1px 2px 10px rgb(0 0 0 / 8%);

  ${(props) =>
    props.blogPost &&
    css`
      background: #fff;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
    `}

  ${(props) =>
    props.viewPost &&
    css`
      top: 11px;
    `}



  ${(props) =>
    props.header &&
    css`
      margin-right: 15px;
      position: static;
    `}
`;

export const UserLine = styled(Box)`
  height: 1px;
  background: #000;
  opacity: 0.1;
`;

export const ErrorText = styled(Box)`
  color: red;
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 15px;
  text-align: left;
`;

export const SuccessText = styled(Box)`
  font-size: 18px;
  font-weight: bold;

  ${(props) =>
    props.active &&
    css`
      color: 3px solid ${props.color};
    `}
`;

export const SubpageArrowBack = styled(Box)`
  width: 30px;
  //transform: rotate(180deg);
  margin-right: 15px;
`;

export const MenuOwnerIcon = styled(Box)``;

export const StyledDiv = styled.div`
  ${(props) =>
    props.overflow &&
    css`
      overflow: ${props.overflow};
    `}
  ${(props) =>
    props.isNoOverflow &&
    css`
      overflow: visible;
    `}

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}
  ${(props) =>
    props.isInsideDashboard &&
    css`
      pointer-events: none;
    `}
`;

export const UserInstaLink = styled.div`
  display: flex;
  align-items: center;
  text-decoration: none;
  flex-grow: 1;
  z-index: 1;
  cursor: pointer;
  overflow: hidden;

  ${(props) =>
    props.isButtonWebsite &&
    css`
      width: 75%;
    `}

  ${(props) =>
    props.hidden &&
    css`
      pointer-events: none;
    `}

  ${(props) =>
    props.insideBody &&
    css`
      position: relative;
      justify-content: center;
      flex-direction: column;
      margin-bottom: ${mainIndent};
      margin-top: ${mainIndent};
    `}

  ${(props) =>
    props.headerCover &&
    css`
      margin-top: -${props.avatarSize / 2 + 12}px;
    `}

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}

  ${(props) =>
    props.headerLayout === 2 &&
    css`
      margin-top: 45px;
      align-items: flex-start;

      ${(props) =>
        !props.location &&
        !props.headerShortBio &&
        css`
          align-items: center;
        `}
    `}


  ${(props) =>
    (props.headerLayout === 3 || props.headerLayout === 5) &&
    css`
      flex: none;
      flex: none;
    `}

  ${(props) =>
    (props.headerLayout === 3 || props.headerLayout === 5) &&
    props.isInsideDashboard &&
    css`
      //flex: inherit;
    `}
  


  ${(props) =>
    props.scrollY > 0 &&
    props.headerLayout === 2 &&
    css`
      margin: 0 0 0 6px;
    `}


  ${(props) =>
    (props.headerLayout === 3 || props.headerLayout === 5) &&
    props.scrollY > 0 &&
    css`
      flex: inherit;
    `}


  ${(props) =>
    props.headerLayout === 5 &&
    props.insideBody &&
    !props.isNoAvatar &&
    css`
      margin-top: 151px;

      ${(props) =>
        !props.isInsideDashboard &&
        css`
          @media (min-width: 768px) {
            margin-top: 380px;
          }
        `}
    `}
`;

export const Global = createGlobalStyle`



  .swiper {
    ${(props) =>
      !props.isInsideDashboard &&
      css`
        overflow: visible !important;

        ${(props) =>
          props.width &&
          css`
            width: ${props.width}px !important;
          `}
      `}
  }
  
  .slider-section-swiper {
    .swiper-horizontal>.swiper-pagination-bullets, .swiper-pagination-bullets.swiper-pagination-horizontal, .swiper-pagination-custom, .swiper-pagination-fraction {
      display: none;
      bottom: 0;
      margin-left: -12px;
    }
  }

  .slider-section-swiper--bottom-pagination {
    .swiper-horizontal>.swiper-pagination-bullets, .swiper-pagination-bullets.swiper-pagination-horizontal, .swiper-pagination-custom, .swiper-pagination-fraction {
      display: none;
      bottom: 0;
      margin-left: -12px;
    }
  }

  .swiper-button-prev,
  .swiper-button-next {
    color: black;
    width: 25px;
    height: 25px;
  }

  .swiper-button-prev::after,
  .swiper-button-next::after {
    font-size: 20px;
  }


  .gallery-swiper {
    .swiper-slide {
      display: flex;
      justify-content: center;
      align-items: center;
      height: auto !important;
    }
  }
  
  
  
  .sliderSwiper {
    .swiper-container {
      overflow: visible !important;
      margin-bottom: ${mainIndent};
      margin-top: ${mainIndent};
    }


    .swiper-wrapper {
      -webkit-transition-timing-function: unset;
      transition-timing-function: unset;
      
      ${(props) =>
        !props.isInsideDashboard &&
        css`
          //width: 100%!important;
          //overflow: scroll hidden;
          overflow: auto hidden;
        `}

      ${(props) =>
        props.viewPost &&
        css`
          padding: 20px !important;
          margin-left: -20px !important;
        `}
      
      &::-webkit-scrollbar {
        width: 12px;
      }

      &::-webkit-scrollbar-track {
        display: none;
      }
    }

    .my-swiper.single:not(.fix-width) {
      width: auto!important;
    }

    .swiper-slide {
      width: auto!important;

      &:last-child {
        padding-right: 26px !important;
      }
    }
  }


  .digitalSlider {
    .swiper-slide {
      width: 100% !important;
    }
  }
  
  .sliderSwiperPreviewProduct .swiper-wrapper {
    transition-timing-function: unset;
    overflow: auto hidden;
    padding: 0 !important;
    margin-left: 8px !important;
    margin-top: 4px;
    margin-bottom: -10px;
  }

  .sliderSwiperPageNavigation .swiper-wrapper {
    margin-left: 0;
    margin-top: 0;
    margin-bottom: -18px;
    max-width: 680px;
  }
  
  
  .flipCaptionDate {
    font-size: 10px !important;


    @media (min-width: 568px) {
      font-size: 10px !important;
    }
  }
  
  .ql-align-center {
    text-align: center;
  }
  
  .ql-align-right {
    text-align: right;
  }

  .ql-align-justify {
    text-align: justify;
  }
  
  ${(props) =>
    !props.isInsideDashboard &&
    css`
      html {
        overflow: hidden;
        width: 100%;
      }

      button {
        font-family: 'Open Sans', sans-serif !important;

        ${(props) =>
          props.font &&
          css`
            font-family: ${props.font}, sans-serif !important;
          `}
      }

      body {
        height: 100%;
        position: fixed;
        /* prevent overscroll bounce*/
        overflow-y: auto !important;
        -webkit-overflow-scrolling: touch;
        /* iOS velocity scrolling */
        width: 100%;
        overflow-x: hidden;

        ${(props) =>
          props.backgroundOpacity &&
          css`
            opacity: ${props.backgroundOpacity};
          `}

        ${(props) =>
          props.font &&
          css`
            font-family: ${props.font}, sans-serif !important;
          `}

        ${(props) =>
          props.isPreview &&
          css`
            box-sizing: content-box;
            //padding-right: 16px;
          `}

        ${(props) =>
          props.viewPost &&
          css`
            overflow: hidden !important;
          `}

        // ${(props) =>
          props.vh &&
          css`
            //   height: ${props.vh}px;
            //
          `}

        ${(props) =>
          props.background &&
          css`
            background: ${props.background};
          `}

        ${(props) =>
          props.gradient &&
          props.backgroundType === 2 &&
          css`
            display: block;
            left: 0;
            top: 0;
            background-image: ${props.gradient};
            //background-image: linear-gradient(rgb(252, 220, 0), rgb(171, 20, 158));
            width: 100%;
            height: 100%;
            background-position: center center;
            background-size: cover;
          `}

        ${(props) =>
          props.backgroundImage &&
          props.backgroundType === 3 &&
          css`
            background: ${props.backgroundBrightness
              ? `linear-gradient(rgba(0, 0, 0, 0.${Math.round(props.backgroundBrightness / 2)}), rgba(0, 0, 0, 0.${props.backgroundBrightness})), url(${props.backgroundImage})`
              : `url(${props.backgroundImage})`};
            background-position: 0 10%;
            background-size: cover;
            background-attachment: fixed;

            @media (max-width: 768px) {
              //background: url(${props.backgroundImage});
              background: ${props.backgroundBrightness
                ? `linear-gradient(rgba(0, 0, 0, 0.${Math.round(props.backgroundBrightness / 2)}), rgba(0, 0, 0, 0.${props.backgroundBrightness})), url(${props.backgroundImage})`
                : `url(${props.backgroundImage})`};
              background-position: 50% 0;
              background-size: cover;
              background-attachment: fixed;
              backdrop-filter: none;
            }
          `}

        ${(props) =>
          props.backgroundAnimation &&
          props.backgroundType === 4 &&
          css`
            background: url(${props.backgroundAnimation});
            background-position: 0 50%;
            background-size: cover;
            background-attachment: fixed;

            @media (max-width: 768px) {
              background: url(${props.backgroundAnimation});
              background-position: 50% 0;
              background-size: cover;
              background-attachment: fixed;
              backdrop-filter: none;
            }
          `}

        ${(props) =>
          props.backgroundAnimation &&
          props.backgroundType === 4 &&
          props.isCustomBackgroundImage &&
          css`
            //background: linear-gradient(to bottom, rgba(0, 246, 252, 0.52), rgba(0, 246, 246, 0.73)), url(${props.backgroundAnimation});
            background: ${props.gradient}, url(${props.backgroundAnimation});
            //background: linear-gradient(to bottom, ${props.gradientColor1}, ${props.gradientColor2}), url(${props.backgroundAnimation});

            background-position: 0 50%;
            background-size: cover;
            background-attachment: fixed;
            backdrop-filter: none;

            @media (max-width: 768px) {
              background: ${props.gradient}, url(${props.backgroundAnimation});

              background-position: 50% 0;
              background-size: cover;
              background-attachment: fixed;
              backdrop-filter: none;
            }
          `}

        ${(props) =>
          !props.isGradientAnimation &&
          props.backgroundType === 4 &&
          props.isCustomBackgroundImage &&
          css`
            background: ${props.gradientBackground}, url(${props.backgroundAnimation});

            @media (max-width: 768px) {
              background: ${props.gradientBackground}, url(${props.backgroundAnimation});
            }
          `}
      }
    `}
  
  ${(props) =>
    props.isInsideDashboard &&
    css`
      section.preview {
        overflow: hidden;
        width: 100%;
        border-radius: 30px;
        transform: scale(1);
      }

      div.preview {
        height: 100%;
        overflow-x: hidden;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        position: sticky;
        box-sizing: content-box;

        ::-webkit-scrollbar {
          width: 0;
        }

        ::-webkit-scrollbar-track {
          background-color: transparent;
        }

        ::-webkit-scrollbar-thumb {
          width: 0;
          background-color: rgba(0, 0, 0, 0);
          border-radius: 0;
        }

        @media (max-width: 768px) {
          width: 100%;
        }

        ${(props) =>
          props.backgroundOpacity &&
          css`
            opacity: ${props.backgroundOpacity};

            &:after {
              content: '';
              position: fixed;
              width: 100%;
              top: 0;
              height: 100%;
              background-image: url(data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PScwIDAgNTEyIDUxMicgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz4KICA8ZmlsdGVyIGlkPSdub2lzZUZpbHRlcic+CiAgICA8ZmVUdXJidWxlbmNlIAogICAgICB0eXBlPSdmcmFjdGFsTm9pc2UnIAogICAgICBiYXNlRnJlcXVlbmN5PScwLjcnCiAgICAgIG51bU9jdGF2ZXM9JzMnIAogICAgICBzdGl0Y2hUaWxlcz0nc3RpdGNoJy8+CiAgICA8ZmVDb2xvck1hdHJpeCBpbj0idHVyYnVsZW5jZSIgdHlwZT0ic2F0dXJhdGUiIHZhbHVlcz0iMCIvPgoKICAgIDxmZUNvbXBvbmVudFRyYW5zZmVyPgogICAgICA8ZmVGdW5jUiB0eXBlPSJkaXNjcmV0ZSIgdGFibGVWYWx1ZXM9IjAgMSIgLz4KICAgICAgPGZlRnVuY0cgdHlwZT0iZGlzY3JldGUiIHRhYmxlVmFsdWVzPSIwIDEiIC8+CiAgICAgIDxmZUZ1bmNCIHR5cGU9ImRpc2NyZXRlIiB0YWJsZVZhbHVlcz0iMCAxIiAvPgogICAgPC9mZUNvbXBvbmVudFRyYW5zZmVyPgogIDwvZmlsdGVyPgogIAogIDxyZWN0IHdpZHRoPScxMDAlJyBoZWlnaHQ9JzEwMCUnIGZpbHRlcj0ndXJsKCNub2lzZUZpbHRlciknLz4KPC9zdmc+);
              background-size: 512px 512px;
              background-repeat: repeat;
              opacity: 0.04;
              mix-blend-mode: overlay;
            }
          `}

        ${(props) =>
          props.font &&
          css`
            font-family: ${props.font}, sans-serif !important;
          `}

        ${(props) =>
          props.isPreview &&
          css`
            box-sizing: content-box;
            //padding-right: 16px;
          `}

        ${(props) =>
          props.viewPost &&
          css`
            overflow: hidden;
          `}

        ${(props) =>
          props.vh &&
          css`
            height: ${props.vh}px;
          `}

        ${(props) =>
          props.background &&
          css`
            background: ${props.background};
          `}

        ${(props) =>
          props.gradient &&
          props.backgroundType === 2 &&
          css`
            display: block;
            left: 0;
            top: 0;
            background-image: ${props.gradient};
            //background-image: linear-gradient(rgb(252, 220, 0), rgb(171, 20, 158));
            //width: 106%;
            height: 100%;
            background-position: center center;
            background-size: cover;
          `}

        ${(props) =>
          props.backgroundImage &&
          props.backgroundType === 3 &&
          css`
            background: ${props.backgroundBrightness
              ? `linear-gradient(rgba(0, 0, 0, 0.${Math.round(props.backgroundBrightness / 2)}), rgba(0, 0, 0, 0.${props.backgroundBrightness})), url(${props.backgroundImage})`
              : `url(${props.backgroundImage})`};
            background-position: 50% 0;
            background-size: cover;
            background-attachment: fixed;

            @media (max-width: 768px) {
              //background: url(${props.backgroundImage});
              background: ${props.backgroundBrightness
                ? `linear-gradient(rgba(0, 0, 0, 0.${Math.round(props.backgroundBrightness / 2)}), rgba(0, 0, 0, 0.${props.backgroundBrightness})), url(${props.backgroundImage})`
                : `url(${props.backgroundImage})`};
              background-position: 50% 0;
              background-size: cover;
              background-attachment: fixed;
              backdrop-filter: none;
            }
          `}


        ${(props) =>
          props.backgroundAnimation &&
          props.backgroundType === 4 &&
          css`
            background: url(${props.backgroundAnimation});
            background-position: 50% 50%;
            background-size: cover;
            background-attachment: fixed;

            @media (max-width: 768px) {
              background: url(${props.backgroundAnimation});
              background-position: 50% 0;
              background-size: cover;
              background-attachment: fixed;
              backdrop-filter: none;
            }
          `}

        ${(props) =>
          props.backgroundAnimation &&
          props.backgroundType === 4 &&
          props.isCustomBackgroundImage &&
          css`
            //background: linear-gradient(to bottom, rgba(0, 246, 252, 0.52), rgba(0, 246, 246, 0.73)), url(${props.backgroundAnimation});
            background: ${props.gradient}, url(${props.backgroundAnimation});
            //background: linear-gradient(to bottom, ${props.gradientColor1}, ${props.gradientColor2}), url(${props.backgroundAnimation});

            background-position: 0 50%;
            background-size: cover;
            background-attachment: fixed;
            backdrop-filter: none;

            @media (max-width: 768px) {
              background: ${props.gradient}, url(${props.backgroundAnimation});

              background-position: 50% 0;
              background-size: cover;
              background-attachment: fixed;
              backdrop-filter: none;
            }
          `}

        ${(props) =>
          !props.isGradientAnimation &&
          props.backgroundType === 4 &&
          props.isCustomBackgroundImage &&
          css`
            background: ${props.gradientBackground}, url(${props.backgroundAnimation});

            @media (max-width: 768px) {
              background: ${props.gradientBackground}, url(${props.backgroundAnimation});
            }
          `}

        // ${(props) =>
          props.backgroundAnimation &&
          props.backgroundType === 4 &&
          css`
            //   background: url(${props.backgroundAnimation});
            //   background-position: 100% 100%;
            //   background-size: contain;
            //   background-attachment: fixed;
            //
            //   @media (max-width: 768px) {
            //     background: url(${props.backgroundAnimation});
            //     background-position: 100% 100%;
            //     background-size: contain;
            //     background-attachment: fixed;
            //     backdrop-filter: none;
            //   }
            //
          `}
      }
    `}
  
  
  ${(props) =>
    props.isInsideDashboard &&
    css`
      .flipClock {
        font-size: 0.37vw !important;
      }

      .flipUnitContainer {
        height: 70px !important;
      }

      .upperCard {
        padding: 0 15px !important;
      }

      .upperCardInsideHeader {
        padding: 0 7px !important;
      }

      .upperCardInsideHeader span,
      .lowerCardInsideHeader span {
        font-size: 2.5em !important;
      }

      .flipCaptionDate {
        font-size: 10px !important;

        @media (min-width: 568px) {
          font-size: 10px !important;
        }
      }

      .flipUnitContainerInsideHeader {
        height: 23px !important;
      }

      .flipCaptionDateInsideHeader {
        margin-top: 0 !important;
        margin-bottom: 3px !important;
      }
    `}
  
  .rct-backdrop-filter-wrapper {
    overflow: visible !important;
    padding: 0 12px;
    width: 100%;
    //min-height: 100vh;
    
    display: flex;
    flex-direction: column;

    flex-grow: 1;
    
    @media (min-width: 768px) {
      backdrop-filter: none !important;
      padding: 0 32px;
      //padding: 0 100px;
    }
    
    ${(props) =>
      props.isGradient &&
      css`
        backdrop-filter: none !important;
      `}

    ${(props) =>
      props.forthHeaderView &&
      css`
        padding-top: 290px !important;
      `}

    ${(props) =>
      props.isInsideDashboard &&
      css`
        padding-left: 12px !important;
        padding-right: 12px !important;
      `}

    ${(props) =>
      props.headerLayout === 4 &&
      props.isShowing &&
      css`
        margin-top: -64px !important;
      `}
  }

  .react-tel-input .selected-flag {
    border: 1px solid #e0e2e9 !important;
    border-radius: 8px !important;
  }
  
  .react-tel-input .flag-dropdown {
    border: 1px solid #e0e2e9 !important;
    border-radius: 8px !important;
  }
  
  .scroll-menu-arrow--disabled {
    visibility: hidden;
  }

  .scroll-menu-arrow {
    @media (max-width: 568px) {
        display: none;
    }
  }

  .menu-wrapper {
    //overflow: visible !important;
  }

  .menu-wrapper--inner {
    display: flex;
  }

  .menu-item-wrapper {
    display: flex !important;
    justify-content: center;
    align-items: center;
    background: #fff;
    border: 1px solid #dadce0;
    border-radius: 18px;
    color: #3c4043;
    cursor: pointer;
    height: 34px;
    position: relative;
    //box-shadow: 0 1px 3px 0 rgb(0 0 0 / 10%);

    margin-right: 6px;

    &:last-child {
      margin-right: 0;
      opacity: 0;
      background: none;
      z-index: -1;
      position: relative;
      pointer-events: none;
    }
    
    img {
      padding: 3px;
    }
  }

  ${(props) =>
    props.headerCover &&
    props.headerLayout === 1 &&
    css`
      .rct-backdrop-filter-wrapper {
        margin-top: -64px !important;
      }
    `}
  
  
 
  


  ${(props) =>
    props.headerCover &&
    props.headerLayout === 3 &&
    css`
      .rct-backdrop-filter-wrapper {
        margin-top: -64px !important;
      }
    `}
    
    ${(props) =>
      props.headerCover &&
      props.headerLayout === 4 &&
      css`
        .rct-backdrop-filter-wrapper {
          margin-top: -64px !important;
        }
      `}
 
  
  
  .web-share-box {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    opacity: 0;
    
    button {
      height: 100%;
    }
  }
`;

// modal
export const ModalInnerPostWrap = styled(Flex)`
  justify-content: ${(props) => props.justifyContent || 'space-between'};
  max-height: ${(props) => props.maxHeight || '600px'};
  -moz-appearance: none;
  -webkit-appearance: none;

  @media (max-width: 767px) {
    max-height: none;
  }

  ${(props) =>
    props.minHeight &&
    css`
      min-height: ${props.minHeight}px;
    `}
`;

export const ModalInnerWrap = styled(Flex)`
  overflow: auto;
  flex-direction: column;
  justify-content: ${(props) => props.justifyContent || 'space-between'};
  max-height: ${(props) => props.maxHeight || '600px'};
  -moz-appearance: none;
  -webkit-appearance: none;

  ${(props) =>
    props.minHeight &&
    css`
      min-height: ${props.minHeight}px;
    `}

  ${(props) =>
    !props.tagsModal &&
    css`
      padding: 0 12px;

      @media (max-width: 767px) {
        max-height: none;
      }
    `}

  ${(props) =>
    props.tagsModal &&
    css`
      padding: 0 12px;
    `}
  

  ${(props) =>
    props.popupHero &&
    css`
      justify-content: flex-end;
      align-items: center;
      height: 100%;

      @media (min-width: 767px) {
        flex-direction: row;
      }
    `}

  ${(props) =>
    props.popupWelcome &&
    css`
      justify-content: flex-start;
      align-items: flex-start;
      height: 100%;

      @media (min-width: 767px) {
        flex-direction: row;
        padding: 0;
      }
    `}

  ${(props) =>
    props.popupCategory &&
    css`
      padding: 0;

      @media (min-width: 767px) {
        flex-direction: column;
        max-height: 450px;
        overflow-x: hidden;
      }
    `}
  

  ${(props) =>
    props.itemAddedCart &&
    css`
      @media (max-width: 567px) {
        position: relative;
        width: 100%;
        height: 100%;
        padding: 0;

        //&:before {
        //  content: '';
        //  position: absolute;
        //  top: 12px;
        //  left: 0;
        //  right: 0;
        //  margin: 0 auto;
        //  width: 36px;
        //  height: 3px;
        //  background: #c8c8c8;;
        //}
      }
    `}

  ${(props) =>
    props.oderModal &&
    css`
      overflow: visible;
      height: 95vh;
      justify-content: flex-start;
    `}


  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  ${(props) =>
    props.isCoupon &&
    css`
      overflow: visible;
    `}
`;

export const ModalImagePreview = styled.img`
  position: absolute;
  top: -2px;
  left: -2px;
  width: 101.3%;
  height: 155px;
  object-fit: cover;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
`;

export const ModalItemAddedCartIconBox = styled(Box)`
  text-align: center;
`;

export const ModalItemAddedCartIcon = styled.img`
  width: 60px;
  height: 60px;

  ${(props) =>
    props.insideModal &&
    css`
      width: 26px;
      height: 26px;
      margin-right: 10px;
    `}
`;

export const ModalItemAddedCartTitle = styled(Box)`
  margin: 10px 0 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: 400;
  text-align: center;

  @media (max-width: 568px) {
    margin: 10px 0 20px 0;
  }
`;

export const ModalItemAddedCartButtonBox = styled(Box)`
  width: 210px;
  margin: 0 auto;

  @media (max-width: 568px) {
    margin-top: auto;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
`;

export const Caption = styled(Box)`
  color: #6c6c6c;
  font-size: 13px;

  ${(props) =>
    props.fontSize &&
    css`
      font-size: ${props.fontSize}px;
    `}

  ${(props) =>
    props.protertiesTitle &&
    css`
      font-size: 16px;
      font-weight: bold;
      color: #000000;
    `}

  ${(props) =>
    props.isNotSelectRequired &&
    css`
      border-bottom: 1px solid red;
    `}
`;

export const SpacerSm = styled(Box)`
  margin-top: 1px;
  margin-bottom: 1px;
`;

export const SpacerCustom = styled(Box)`
  ${(props) =>
    props.value &&
    css`
      margin-top: ${props.value}px;
      margin-bottom: ${props.value}px;
    `}
`;

export const CustomFormCheckboxList = styled(Box)`
  display: flex;
  padding: 5px 0 15px 0;
`;

export const InputLabelCheckbox = styled.label`
  display: block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 16px;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.flex &&
    css`
      display: flex;
    `}


  ${(props) =>
    props.disabled &&
    css`
      cursor: default;
    `}

  ${(props) =>
    props.emailCollect &&
    css`
      padding: 0;
      align-items: center;
      display: flex;
    `}

  ${(props) =>
    props.appointment &&
    css`
      font-size: 14px;
    `}

  ${(props) =>
    props.insideMedia &&
    css`
      margin: 10px 0;
    `}

  ${(props) =>
    props.minWidth &&
    css`
      min-width: ${props.minWidth};
    `}
`;

export const Checkmark = styled.span`
  position: absolute;
  top: -3px;
  left: 0;
  height: 24px;
  width: 24px;
  background-color: transparent;
  border: 1px solid #e0e2e9;
  border-radius: 5px;

  &:after {
    content: '';
    position: absolute;
    display: none;
    left: 7px;
    top: 3px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  ${(props) =>
    props.disabled &&
    css`
      cursor: default;
      opacity: 0.5;
    `}

  ${(props) =>
    props.topCheckMark &&
    css`
      top: ${props.topCheckMark};
    `}
`;

export const CustomFormFieldTitle = styled(Box)`
  white-space: pre-wrap;
  color: #000000;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const InputLabelRadio = styled.label`
  margin-left: -0.8em;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 16px;
  cursor: pointer;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.flex &&
    css`
      display: flex;
      align-items: center;
    `}
  ${(props) =>
    props.gap &&
    css`
      gap: ${props.gap};
    `}
  
  ${(props) =>
    props.column &&
    css`
      flex-direction: column;
    `}

  ${(props) =>
    props.appointment &&
    css`
      position: absolute;
      left: 14px;
    `}

  ${(props) =>
    props.filter &&
    css`
      font-size: 18px;
    `}
`;

export const InputRadio = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;

  ${(props) =>
    props.notAbsolute &&
    css`
      position: relative;
    `}

  &:checked ~ span {
    background: #ffc561;
    box-shadow: inset 0 0 0 2px #fff;
    border: 2px solid #ffc561;

    :after {
      display: block;
    }
  }
`;

export const SpacerMd = styled(Box)`
  margin-top: 2px;
  margin-bottom: 2px;
`;

export const DirectMessage = styled(Box)`
  padding: 10px;
  margin-bottom: 20px;
  background: #f1f1f1;
  line-height: 24px;
  height: 87px;
  overflow: auto;

  @media (max-width: 568px) {
    word-break: break-word;
  }
`;

export const Messengers = styled(Box)`
  margin-top: 60px;

  ${(props) =>
    props.directMessage &&
    css`
      margin-top: 10px;
    `}
`;

export const MessengersTitle = styled(Box)`
  text-align: center;
  font-size: 18px;
  color: #494949;
`;

export const ImagePostTag = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;

  width: 24px;
  height: 24px;
  background: #fff;
  border-radius: 50%;

  text-align: center;
  line-height: 25px;
  font-size: 14px;
  color: #000;
  cursor: pointer;

  animation: 5s ${keyframes`
      0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
      }
    
      70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
      }
    
      100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
      }`};
  animation-iteration-count: infinite;

  ${(props) =>
    props.top &&
    css`
      top: ${props.top}px;
    `}

  ${(props) =>
    props.left &&
    css`
      left: ${props.left}px;
    `}
`;

export const ImagePostTagTip = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;

  width: 120px;
  height: 30px;
  background: #fff;

  text-align: center;
  line-height: 25px;
  color: #000;
  cursor: pointer;
  border-radius: 8px;

  display: flex;
  font-size: 12px;
  justify-content: space-around;
  align-items: center;

  &:after {
    content: '';
    position: absolute; /* Абсолютное позиционирование */
    top: -18px; /* Положение треугольника */
    border: 10px solid transparent; /* Прозрачные границы */
    border-bottom: 10px solid #fff; /* Добавляем треугольник */
  }

  ${(props) =>
    props.top &&
    css`
      top: ${props.top}px;
    `}

  ${(props) =>
    props.left &&
    css`
      left: ${props.left}px;
    `}
`;

export const ImagePostTagTitle = styled(Box)`
  max-width: 70px;
  max-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;
`;

export const ImagePostTagPrice = styled(Box)`
  max-width: 38px;
  max-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ListTag = styled(Box)`
  margin-top: 15px;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.table &&
    css`
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    `}
`;

export const TagImage = styled.img`
  width: 55px;
  height: 55px;
  object-fit: cover;
  //transition: all .3s;

  border: 1px solid rgb(221, 221, 221);

  transition: border 0.25s ease-in-out 0s;

  ${(props) =>
    props.columnStyle &&
    css`
      width: 100%;
      height: 160px;
      border-radius: 6px;
    `}

  ${(props) =>
    props.isMobile &&
    css`
      height: 95px !important;
    `}

  ${(props) =>
    props.oneTag &&
    css`
      height: 260px;
      width: 100%;
      border-radius: 6px;
    `}
`;

export const TagImageBox = styled(Box)`
  width: 55px;
  height: 55px;
  margin-bottom: 5px;

  ${(props) =>
    props.columnStyle &&
    css`
      height: 160px;
      flex-grow: 1;
      width: 100%;
      text-align: center;
    `}

  ${(props) =>
    props.isMobile &&
    css`
      height: 95px !important;
    `}

  ${(props) =>
    props.isShowingTikTokTags &&
    css`
      margin-bottom: 0;
    `}

  ${(props) =>
    props.oneTag &&
    css`
      height: 260px;
      flex-grow: 1;
      width: 100%;
      text-align: center;
    `}
`;

export const TagItem = styled(Box)`
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e9e9e9;
  cursor: pointer;
  position: relative;

  ${ButtonTransparent} {
    display: none;
    cursor: pointer;
  }

  &:hover ${ButtonTransparent} {
    display: block;
  }

  &:hover ${TagImage} {
    border: 1px solid rgb(0, 0, 0);
  }

  ${(props) =>
    props.columnStyle &&
    css`
      flex-wrap: wrap;
      border-bottom: none;
    `}

  ${(props) =>
    props.table &&
    css`
      width: 48%;
    `}
`;

export const TagNumber = styled(Box)`
    box-sizing: border-box;
    margin: -10px 10px 0 0;

    line-height: 21px;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    width: 22px;
    height: 22px;
    border: 1.5px solid rgb(0, 0, 0);
    border-radius: 50%;
    
    ${(props) =>
      props.textColor &&
      css`
        border-color: ${props.textColor};
      `}

    ${(props) =>
      props.absolute &&
      css`
        position: absolute;
        top: 2px;
        left: 2px;
        background: #fff;
        margin: 0;
      `}
    
}
`;

export const TagInfo = styled(Box)`
  margin-left: 10px;
  margin-bottom: 12px;

  ${(props) =>
    props.columnStyle &&
    css`
      margin-left: 0;
      width: 100%;
    `}

  ${(props) =>
    props.isMobile &&
    css`
      @media (max-width: 568px) {
        margin-left: 0;
        width: 83%;
      }
    `}

  ${(props) =>
    props.isShowingTikTokTags &&
    css`
      padding: 5px;
      background: #fff;
    `}
`;

export const TagDescription = styled(Box)`
  max-width: 190px;
  max-height: 36px;
  margin-bottom: 5px;
  word-break: break-word;
  overflow: hidden;

  line-height: normal;
  font-size: 11px;
  font-weight: 500;
  color: black;
  letter-spacing: 0.28px;
  margin-top: 0;
  text-align: left;
  text-transform: uppercase;

  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}

  ${(props) =>
    props.columnStyle &&
    css`
      height: 28px;
    `}

  ${(props) =>
    props.oneTag &&
    css`
      font-size: 18px;
      margin: 0;
      text-transform: initial;
      width: 100%;
      max-width: initial;
    `}
`;

export const TagPriceBox = styled(Box)`
  position: relative;
  display: flex;
  font-size: 16px;
  height: 18px;

  ${(props) =>
    props.columnStyle &&
    css`
      font-size: 13px;
      height: 15px;
    `}

  ${(props) =>
    props.oneTag &&
    css`
      font-size: 20px;
      margin: 0;
      height: initial;
    `}
`;

export const TagPrice = styled(Box)`
  margin-right: 10px;
  color: #0099ff;

  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}

  ${(props) =>
    props.oneTag &&
    css`
      color: #000;
    `}
`;

export const TagOldPrice = styled(Box)`
  color: #999;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: -2px;

    width: 100%;
    height: 2px;
    margin-top: -2px;
    background: #999;
  }

  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};

      &:before {
        background: ${props.textColor};
      }
    `}

  ${(props) =>
    props.insideTagsList &&
    css`
      &:before {
        top: 63%;
        margin-top: 0;
      }
    `}
`;

export const TagShareLink = styled(Box)`
  margin-top: -1px;
  margin-left: auto;
`;

export const TagIconShareLink = styled.img`
  width: 25px;
  height: 21px;
`;
export const LinkedIcon = styled.img`
  ${(props) => props.color && css``}
`;

export const PhotoBoxContent = styled(Box)`
  position: absolute;
  width: 100%;
  height: 100%;
`;

export const AddToBasketMessage = styled(Flex)`
  position: fixed;
  margin: auto;
  bottom: -100px;
  background: #0f834d;
  width: 100%;
  height: 52px;
  max-width: 680px;
  text-align: center;
  display: none;
  ${(props) =>
    props.show &&
    css`
      display: block;
      z-index: 102;
      text-align: center;
      bottom: 0;
    `}
`;
export const AddToCartTextInBlock = styled(Flex)`
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  font-size: 1.2em;
`;

export const ButtonLinkTitle = styled(Box)`
  font-weight: bold;
  overflow: hidden;
  white-space: normal;
  //max-height: 64px;
  text-overflow: clip;
  line-height: 1.2;
  text-align: center;

  ${(props) =>
    props.isDescription &&
    css`
      margin-bottom: 6px;
      text-align: left;
    `}

  ${(props) =>
    props.isImage &&
    css`
      padding-right: 35px;

      @media (max-width: 797px) {
        padding-right: 35px;
      }
    `}

  ${(props) =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}

  ${(props) =>
    props.isFullMode &&
    css`
      padding-right: 17%;
      @media (max-width: 797px) {
        padding-right: 17%;
      }
    `}
`;

export const ButtonLinkSectionBox = styled(Box)`
  padding: 1px 12px;
  //margin-top: 40px;

  ${(props) =>
    props.isIncreaseMargin &&
    css`
      margin-top: 20px;
    `}
`;

export const ButtonAnimationWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const ButtonLinkSeparatorIconBox = styled(Box)`
  margin-top: 20px;
`;

export const ButtonLinkSectionTitle = styled(Box)`
  margin-bottom: 16px;
  font-size: 22px;
  font-weight: bold;
  overflow: hidden;
  word-wrap: break-word;

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${(props) =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}
`;

export const ButtonLinkSectionSubtitle = styled(Box)`
  margin: 16px 0;
  overflow: hidden;
  word-wrap: break-word;

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${(props) =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}
`;

export const ButtonLinkSectionImage = styled.img`
  display: block;
  margin: 0 auto;
  max-width: 350px;
  width: 100%;
  height: auto;
  max-height: 260px;
  object-fit: cover;
  border-radius: 8px;
`;

export const ButtonLinkSeparatorBox = styled(Box)`
  position: relative;
  //margin-top: -20px;
  //margin-bottom: 20px;

  width: 180px;
  margin: -20px auto 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 48%;
    width: 75%;
    height: 1px;
    background: linear-gradient(to right, #000 0, #fff0 100%);
    opacity: 0.8;
  }

  &:before {
    transform: translate(50%, 0);
  }

  &:after {
    transform: scale(-1, 1) translateX(50%);
  }

  ${(props) =>
    props.isIcon &&
    css`
      &:before {
        transform: translate(68%, 0);
      }

      &:after {
        transform: translate(-68%, 0) rotate(180deg);
      }
    `}

  ${(props) =>
    props.color &&
    css`
      &:before,
      &:after {
        background: linear-gradient(to right, ${props.color} 0, #fff0 100%);
      }
    `}

  ${(props) =>
    props.isOneLine &&
    css`
      &:before,
      &:after {
        width: 35%;
      }
    `}

  ${(props) =>
    props.isBigOneLine &&
    css`
      &:before,
      &:after {
        width: 107%;
        height: 1px;
        background: rgba(0, 0, 0, 0.3);
      }
    `}
`;

export const ButtonLinkSeparatorIcon = styled.img`
  //padding: 0 10px;
  width: 30px;
  height: 30px;

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
`;

export const ButtonLinkArrowBox = styled(Box)`
  margin-top: -12px;
  position: absolute;
  top: 50%;
  right: 20px;

  ${(props) =>
    props.insideButton &&
    css`
      margin-top: -13px;
    `}

  ${(props) =>
    props.insideActiveButton &&
    css`
      right: 8px;
    `}

  ${(props) =>
    props.isRightArrowAngle &&
    css`
      margin-top: -10px;
    `}

  ${(props) =>
    props.buttonLinkMode === 'card' &&
    css`
      top: calc(50% + ${props.height / 2}px);
    `}
`;

export const ButtonLinkImageBox = styled(Box)`
  position: absolute;
  top: 50%;
  left: 10px;
  width: 50px;
  height: 50px;
  margin-top: -25px;
  border-radius: 4px;

  ${(props) =>
    props.isButtonRadius &&
    css`
      border-radius: 36px !important;

      &:hover {
        border-radius: 36px !important;
      }
    `}

  ${(props) =>
    props.buttonLinkMode === 'full' &&
    css`
      margin-top: 0;
      width: 33%;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      border-radius: 0 !important;

      &:hover {
        border-radius: 0 !important;
      }
    `}

  ${(props) =>
    props.buttonLinkMode === 'card' &&
    css`
      top: 0;
      left: 0;
      margin: 0;
      width: 100%;
      height: ${props.height}px;
    `}
`;

export const ButtonLinkImage = styled.img`
  width: 50px;
  height: 50px;

  ${(props) =>
    props.buttonLinkMode === 'round' &&
    css`
      border-radius: 36px !important;

      &:hover {
        border-radius: 36px !important;
      }
    `}

  ${(props) =>
    props.buttonLinkMode === 'card' &&
    css`
      width: 100%;
      height: ${props.height}px;
      object-fit: cover;
    `}


  ${(props) =>
    props.buttonLinkMode === 'full' &&
    css`
      width: 100%;
      object-fit: cover;
      height: 100%;

      border-radius: 0 !important;

      &:hover {
        border-radius: 0 !important;
      }
    `}
`;

export const ButtonLinkDescription = styled(Box)`
  text-align: left;
  font-size: 14px;
  overflow: hidden;
  white-space: normal;
  text-overflow: clip;
  line-height: 1.3;
  opacity: 0.7;

  ${(props) =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}

  ${(props) =>
    props.isImage &&
    css`
      padding-right: 35px;

      @media (max-width: 797px) {
        padding-right: 35px;
      }
    `}


    ${(props) =>
    props.isFullMode &&
    css`
      padding-right: 17%;
      @media (max-width: 797px) {
        padding-right: 17%;
      }
    `}
`;

export const ModalOrderImageBox = styled(Box)`
  position: relative;
  left: -16px;
  height: 260px;
  margin-bottom: 5px;
  //border: 1px solid #dadce0;
`;

export const ModalOrderFormFields = styled(Box)`
  ${(props) =>
    props.isNotAvailable &&
    css`
      margin-bottom: 30px;
    `}
`;

export const ModalOrderImage = styled.img`
  height: 100%;
  width: calc(100% + 31px);
  object-fit: cover;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
`;

export const LabelList = styled(Box)`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1;
`;

export const LabelBox = styled(Box)`
  margin-bottom: 10px;
  width: auto;
  padding: 7px;
  border-radius: 30px;

  ${(props) =>
    props.background &&
    css`
      background: ${props.background};
    `}
`;

export const LabelText = styled(Box)`
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  max-width: 140px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  ${(props) =>
    props.background &&
    css`
      color: ${props.background === '#ffffff' ? '#000' : '#fff'};
    `}

  ${(props) =>
    props.view === 4 &&
    css`
      max-width: none;
    `}
`;

export const PhotoBoxTap = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  text-align: center;
  animation: ${pulseAnimation} 2s infinite;
`;

export const PhotoBoxTapIcon = styled.svg`
  width: 40%;
  height: 100%;
`;

export let TextTitleHeading = styled(Box)`
  font-weight: bold;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 8px 0 0 0;
  height: 28px;

  ${(props) =>
    props.mobileView === 4 &&
    css`
      font-size: 15px;

      overflow: initial;
      text-overflow: initial;
      white-space: initial;
      height: auto;
    `}
`;

export let TextTitleDescription = styled(Box)`
  position: relative;
  font-size: 12px;
  line-height: 1.2;
  height: 44px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;

  &:after {
    position: absolute;
    left: 0;
    bottom: 0;
    content: '';
    width: 100%;
    height: 3px;
    background: #fff;

    ${(props) =>
      props.background &&
      css`
        background: ${props.background};
      `}
  }

  ${(props) =>
    props.mobileView === 4 &&
    css`
      position: static;
      margin-top: 5px;
      font-size: 14px;
      line-height: normal;

      height: auto;
      max-height: 56px;

      &:after {
        display: none;
      }
    `}

  ${(props) =>
    props.isRedirect &&
    css`
      max-height: initial;
    `}
`;

export let TextPriceBox = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin: 10px 0 0 0;
  font-size: 15px;
  min-height: 19px;

  ${(props) =>
    props.insidePostLayout &&
    css`
      margin: 0;
      position: relative;
      min-height: 30px;
    `}
  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export let QuantityBox = styled(Box)`
  margin-bottom: 5px;
  padding: 3px 10px;
  display: inline-flex;
  background: #f5f5f5;
  border-radius: 3px;
`;

export let QuantityText = styled.span`
  font-size: 11px;

  ${(props) =>
    props.isAvailable &&
    css`
      //background-color: #00ac450d;
      color: #00ac45;

      span {
        margin: 0 5px -1px 0;
      }
    `}
`;

export let TextPriceBoxItem = styled(Box)`
  display: flex;
  align-items: center;

  ${(props) =>
    props.insidePostLayout &&
    css`
      justify-content: center;
      align-items: flex-start;
      flex-direction: column;
      height: 33px;
    `}
`;

export let TextPriceLikeCount = styled(Box)`
  margin-right: 5px;
  font-size: 14px;

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${(props) =>
    props.isHide &&
    css`
      display: none;
      background: red;
    `}

  ${(props) =>
    props.isInsideDashboard &&
    css`
      display: none;
      visibility: hidden;
      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;
      background: green;
    `}
`;

export let TextPriceLikeIconBox = styled(Box)`
  width: 22px;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export let TextCurrentPrice = styled(Box)`
  margin-right: 15px;

  ${(props) =>
    props.insidePostLayout &&
    css`
      font-size: 14px;
    `}

  ${(props) =>
    props.mobileView === 4 &&
    css`
      font-size: 15px;
    `}
`;

export let TextOldPrice = styled(Box)`
  position: relative;

  &:after {
    content: '';
    position: absolute;
    top: 8px;
    left: 0;
    width: 100%;
    height: 1px;
    background: #000;
  }

  ${(props) =>
    props.insidePostLayout &&
    css`
      opacity: 0.6;
      font-size: 12px;

      &:after {
        top: 6px;
      }
    `}
`;

export const FooterStyled = styled.footer`
  margin: auto 0 0;
  display: flex;
  //padding-top: 30px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  color: transparent;
  opacity: 0;
  height: 150px;

  ${(props) =>
    props.isWhiteFooter &&
    css`
      background: #fff;
    `}

  ${(props) =>
    !props.isHideFooter &&
    css`
      color: #000;
      opacity: 1;
    `}

  ${(props) =>
    props.isBottom &&
    css`
      margin-top: 0;
      height: 50px;
    `}
`;

export const MediaProperties = styled(Box)``;

export const MediaPropertiesList = styled(Box)``;

export const MediaPropertiesItem = styled(Box)`
  ${(props) =>
    props.insideLook &&
    css`
      display: flex;
      justify-content: space-between;
      align-items: center;
    `}
`;

export const PropertiesHeading = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const PropertiesList = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 8px;
`;

export const PropertiesItem = styled(Box)`
  margin-right: 12px;
  margin-bottom: 12px;
  cursor: pointer;
  min-width: 30px;

  ${(props) =>
    props.background &&
    css`
      background: ${props.background};
    `}

  ${(props) =>
    props.string &&
    css`
      padding: 0 8px;
      text-align: center;
      line-height: 30px;
      font-weight: bold;
      font-size: 14px;

      width: auto;
      height: 30px;

      border-radius: 18px;
    `}

  ${(props) =>
    props.isColor &&
    css`
      width: 30px;
      height: 30px;
      border-radius: 50%;
    `}
  
  ${(props) =>
    props.activeColor &&
    css`
      position: relative;
      //border: 3px #17ce17 solid;

      &:before {
        position: absolute;
        top: -4px;
        right: -12px;
        content: '';
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background-color: #000;
        border: 3px solid #fff;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fff;opacity:0;%7D.cls-2%7Bfill:%23fff;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Echeckmark%3C/title%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='checkmark'%3E%3Cg id='checkmark-2' data-name='checkmark'%3E%3Crect class='cls-1' width='24' height='24'/%3E%3Cpath class='cls-2' d='M9.86,18a1,1,0,0,1-.73-.32L4.27,12.51a1,1,0,1,1,1.46-1.37l4.12,4.39,8.41-9.2a1,1,0,1,1,1.48,1.34l-9.14,10a1,1,0,0,1-.73.33Z'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      }
    `}

  ${(props) =>
    props.activeString &&
    css`
      color: #fff;
      background: #000;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.isBorderColor &&
    css`
      border: 1px solid #b5b9bf;
    `}
`;

export const ModalPropertiesList = styled(Box)`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

export const ModalPropertiesItem = styled(Box)``;

export const ModalPropertiesInputBox = styled(Box)`
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow-y: auto;
`;

export const LoadingPreview = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  transform: scale(1.1);

  filter: blur(5px);
  -webkit-filter: blur(5px);

  background-image: url(${(props) => props.previewImage});
  background-position: 50% 0;
  background-size: cover;
  background-attachment: fixed;
  backdrop-filter: none;

  //opacity: 0.5;
  //filter: blur(8px) grayscale(100%);

  display: flex;

  justify-content: center;
  align-items: center;
`;

export const LoadingBox = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 1000;

  display: flex;

  justify-content: center;
  align-items: center;
  background: #fff;
`;

export const LoadingPreviewSpinnerBox = styled(Box)`
  position: relative;
  margin-top: -30px;
  background: #9a9a9a;
  border-radius: 15px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 160px;
  height: 160px;
`;

export const LoadingPreviewTitle = styled(Box)`
  margin-top: 14px;
  font-weight: bold;
  color: #ffffff;
`;

export const LoadingPreviewWrapper = styled(Box)`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const AvatarBox = styled(Box)`
  display: flex;
  justify-content: center;

  ${(props) =>
    props.iconSvg &&
    css`
      width: 42px;
      height: 42px;
      margin: 0 auto;
    `}
`;

export const TitleBox = styled(Box)`
  margin: 15px 0;
  padding: 0 42px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: #fff;

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${(props) =>
    props.fontSize &&
    css`
      font-size: ${props.fontSize};
    `}

    ${(props) =>
    props.fontWeight &&
    css`
      font-weight: ${props.fontWeight};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  ${(props) =>
    props.search &&
    css`
      padding: 0;
      margin: -5px 0 0;
    `}
`;

export const TextDescription = styled(Box)`
  font-size: 14px;
  font-weight: normal;
  line-height: 17px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 68px;

  ${(props) =>
    props.isButton &&
    css`
      max-height: 34px;
    `}
`;

export const UserMenuBox = styled(Box)`
  position: fixed;
  bottom: 10px;
`;

export const ShareProductList = styled(Box)`
  margin-top: 25px;
  display: flex;
  justify-content: space-between;
`;

export const ShareProductItem = styled(Box)`
  width: 25%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 25px;
`;

export const ShareProductIconBox = styled(Box)`
  width: 50px;
  height: 50px;

  ${(props) =>
    props.copyIcon &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      background: #828282;
      border-radius: 50%;
    `}

  ${(props) =>
    props.isApiIcon &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      border-radius: 50%;
    `}

  ${(props) =>
    props.bgColor &&
    css`
      background: ${props.bgColor};
    `}
`;

export const ShareProductIcon = styled.img`
  width: 50px;
  height: 50px;

  ${(props) =>
    props.copyIcon &&
    css`
      width: 26px;
      height: 26px;
    `}

  ${(props) =>
    props.size &&
    css`
      width: ${props.size};
      height: ${props.size};
    `}
`;

export const ShareProductTitle = styled(Box)`
  margin-top: 7px;
`;

export const AdminBox = styled(Box)`
  position: fixed;
  bottom: 15px;
  left: 0;
  right: 0;
  z-index: 199;
  display: none;
  width: 175px;
  padding: 17px;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  background: #000;
  color: #fff;
  cursor: pointer;

  ${(props) =>
    props.isShowing &&
    css`
      display: flex;
    `}

  ${(props) =>
    props.pageNavigation === pageNavigationTypes.bottom &&
    css`
      bottom: 60px;
    `}
`;

export const AdminBoxIcon = styled.img`
  width: 19px;
  height: 19px;
`;

export const AdminBoxTitle = styled(Box)`
  margin-left: 10px;
  font-size: 18px;
  text-transform: uppercase;
`;

export const TagsModalText = styled(Box)`
  display: flex;
  justify-content: center;
  margin-top: 50px;
  font-size: 18px;
`;

export const EditBlockButton = styled(Box)`
  display: none;

  position: absolute;
  top: 15px;
  right: 20px;
  cursor: pointer;
  color: #4e75fe;

  ${(props) =>
    props.isShowing &&
    css`
      display: block;
    `}
`;

export const ContentSwitchActiveBox = styled(Box)`
   display: block;
   //margin-top: -5px;
   margin-bottom: 25px;
   padding: 15px;
   box-shadow: 1px 2px 10px rgb(0 0 0 / 8%);
   border-radius: 8px;
   border-top-left-radius: 0;
   border-top-right-radius: 0;

  ${(props) =>
    props.timer &&
    css`
      display: flex;
      justify-content: space-between;
      align-items: center;
    `}

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  ${(props) =>
    props.hideBoxShadow &&
    css`
      box-shadow: none;
    `}
  
}
`;

export const DonationWrapper = styled(Box)`
  margin-bottom: ${mainIndent};
  margin-top: ${mainIndent};

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin}px 0;
    `}
`;

export const DonationInlineBox = styled(Box)`
  padding: 26px;
  border-radius: 6px;

  ${(props) =>
    props.bgColor &&
    css`
      background: ${props.bgColor};
    `}

  ${(props) =>
    props.isBorder &&
    css`
      border: 1px solid ${props.borderColor};
    `}

  ${(props) =>
    props.isInsideModal &&
    css`
      padding: initial;
      border-radius: initial;
      background: transparent;
      border: none;
    `}


  ${(props) =>
    props.isFullWidth &&
    !props.isInsideModal &&
    css`
      ${fullWidthSection};
    `}

  ${(props) =>
    props.isFullWidth &&
    props.isInsideDashboard &&
    !props.isInsideModal &&
    css`
      padding-left: 32px;
      padding-right: 32px;
    `}


  ${(props) =>
    props.shadow === 'soft' &&
    !props.isInsideModal &&
    css`
      ${shadowSoft};
    `}

  ${(props) =>
    props.shadow === 'hard' &&
    !props.isInsideModal &&
    css`
      ${shadowHard};
    `}

  ${(props) =>
    props.isInsideDashboard &&
    css`
      pointer-events: none;
    `}

  

  ${(props) =>
    Boolean(props.sectionPadding) &&
    css`
      padding-top: ${props.sectionPadding}px;
      padding-bottom: ${props.sectionPadding}px;
    `}
`;

export const DonationPreviewPrice = styled(Box)`
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 10px;
  font-size: 36px;
  text-align: center;
`;

export const DonationPreviewMoney = styled(Box)`
  display: flex;
  justify-content: center;
  font-size: 48px;
  font-weight: bold;
`;

export const DonationMoneyInput = styled.div`
  outline: none;
  box-shadow: none;
`;

export const DonationMoneyTrailing = styled.div``;

export const DonationPreviewCurrency = styled(Box)`
  position: absolute;
  width: 100%;
  z-index: 0;
`;

export const DonationInputBox = styled(Box)`
  width: min-content;
`;

export const DonationContainer = styled(Box)`
  padding: 15px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fef6f7;
  border-radius: 3px;
  border: 1px solid #f9e8e9;

  ${(props) =>
    props.bgColor &&
    css`
      background: rgba(${props.bgColor.r}, ${props.bgColor.g}, ${props.bgColor.b}, 0.2);
      border: 1px solid rgba(${props.bgColor.r}, ${props.bgColor.g}, ${props.bgColor.b}, 0.3);
    `}
`;

export const DonationCostsBox = styled(Box)`
  font-size: 12px;
  margin: 5px 0;
  color: #848484;
`;

export const DonationAmountsList = styled(Box)`
  width: 100%;
  margin: 15px 0 0;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const DonationAmountsItem = styled(Box)`
  flex: 1 0 20%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  font-weight: bold;
  font-size: 18px;
  background: #e9eef0;
  border-radius: 6px;

  &:last-child {
    margin-right: 0;
  }

  ${(props) =>
    props.active &&
    props.bgColor &&
    props.color &&
    css`
      color: ${props.color};
      background: ${props.bgColor};
      //border: 1px solid rgba(${props.borderColor.r}, ${props.borderColor.g}, ${props.borderColor.b}, 0.8);
    `}
`;

export const DonationEmojiBox = styled(Box)`
  position: relative;
  font-size: 32px;
`;

export const DonationTotalBold = styled(Box)`
  font-size: 18px;
  font-weight: bold;
`;

export const DonationX = styled(Box)`
  padding-left: 4px;
  padding-right: 30px;
  position: relative;
  &:after {
    content: '✕';
    position: absolute;
    top: 2px;
    right: 10px;
    width: 10px;
    height: 10px;
    font-size: 14px;
    color: #bdb4b5;
  }
`;

export const DonationItemList = styled(Box)`
  display: flex;
`;

export const DonationItem = styled(Box)`
  flex: none;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  width: 40px;
  height: 40px;
  color: #e2a6a4;
  cursor: pointer;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #f2e7e9;

  ${(props) =>
    props.bgColor &&
    css`
      color: ${props.bgColor};
    `}

  ${(props) =>
    props.active &&
    css`
      color: #fff;
      background: #fc5f5e;
    `}
  
  ${(props) =>
    props.active &&
    props.bgColor &&
    props.color &&
    css`
      color: ${props.color};
      background: ${props.bgColor};
      border: 1px solid rgba(${props.borderColor.r}, ${props.borderColor.g}, ${props.borderColor.b}, 0.8);
    `}

  ${(props) =>
    props.isInsideDashboard &&
    css`
      width: 32px;
      height: 32px;
    `}
`;

export const DonationMessageBox = styled(Box)`
  min-height: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 24px;
`;

export const PricePhotoBox = styled(Box)`
  position: absolute;
  bottom: 10px;
  left: 10px;
  padding: 5px 15px;
  border-radius: 20px;
  max-width: 100%;

  ${(props) =>
    props.bgColor &&
    css`
      background: ${props.bgColor};
    `}

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  ${(props) =>
    props.isOldPrice &&
    css`
      border-radius: 10px;
    `}
`;

export const PhotoBoxLike = styled(Box)`
  display: none;

  position: absolute;
  top: 10px;
  right: 10px;
  //bottom: 10px;
  //right: 10px;
  padding: 3px 10px;
  align-items: center;
  border-radius: 20px;

  ${(props) =>
    props.isViewPost &&
    css`
      top: unset;
      bottom: 10px;
    `}
  ${(props) =>
    props.bgColor &&
    css`
      background: ${props.bgColor};
    `}

  ${(props) =>
    props.isCircle &&
    css`
      padding: 3px;
    `}


  ${(props) =>
    props.isShowing &&
    css`
      display: flex;
    `}

  ${(props) =>
    props.isLeft &&
    css`
      left: 10px;
      right: initial;
    `}
`;

export const PricePhotoBoxText = styled(Box)`
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${(props) =>
    props.bold &&
    css`
      font-weight: bold;
    `}
  ${(props) =>
    props.title &&
    css`
      font-size: 16px;
      font-weight: bold;
    `}
  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}
`;

export const OldPricePhotoBoxText = styled.span`
  position: relative;
  font-size: 12px;
  font-weight: 400;
  opacity: 0.6;

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    margin-top: -1px;
    left: 0;
    width: 100%;
    height: 1px;
  }

  ${(props) =>
    props.bold &&
    css`
      font-weight: bold;
    `}

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};

      &:before {
        background: ${props.color};
      }
    `}
`;

export const MenuMoreBox = styled(Box)`
  flex: none;
  margin: 8px 0 8px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  background: rgba(255, 255, 255, 0.7);
  border-radius: 50%;
  height: 35px;
  width: 35px;

  ${(props) =>
    props.headerLayout === 2 &&
    css`
      margin: 0;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const TogglePasswordBox = styled(Box)`
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const PasswordIcon = styled.img`
  width: 28px;
  height: 28px;
`;

export const ModalPaymentContent = styled(Box)``;

export const ModalPaymentTotal = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
`;

export const ModalPaymentTotalText = styled(Box)`
  font-size: 18px;
  color: #838383;
`;

export const ModalPaymentTotalValue = styled(Box)`
  font-size: 20px;
  font-weight: bold;
`;

export const BasketIndent = styled(Box)`
  width: 100%;
  height: 12px;

  ${(props) =>
    props.bg &&
    css`
      background: ${props.bg};
    `}

  ${(props) =>
    props.underTotal &&
    css`
      margin: 0 18px 0 12px;
      width: auto;
      position: relative;
      top: -32px;
      height: 3px;
    `}

  ${(props) =>
    props.insideItemAdded &&
    css`
      flex: none;
    `}

  ${(props) =>
    props.height &&
    css`
      height: ${props.height};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const AddBlockButtonBox = styled(Box)`
  margin-top: 30px;
  display: none;

  ${(props) =>
    props.isShowing &&
    css`
      display: block;
    `}
`;

export const ContentMenuItemHeader = styled(Box)`
  display: flex;
  align-items: center;

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.editModal &&
    css`
      position: absolute;
      top: 18px;
      left: 27px;
    `}
`;

export const ContentBackIcon = styled.img`
  margin-right: 28px;
  width: 30px;
  height: 30px;
  transform: rotate(180deg);
  cursor: pointer;

  ${(props) =>
    props.backButtonLink &&
    css`
      position: absolute;
      top: 18px;
      left: 23px;
      width: 25px;
      height: 25px;
    `}

  ${(props) =>
    props.WebsiteMenuItem &&
    css`
      @media (max-width: 568px) {
        left: 10px;
        position: absolute;
        top: -50px;
      }
    `}
`;

export const AddedSectionList = styled(Box)`
  display: flex;
  justify-content: space-between;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const AddedSectionItem = styled(Box)`
  width: 47%;

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const ModalSubscribeList = styled(Box)`
  margin: 18px 0 24px 0;
  padding: 0;
`;

export const ModalSubscribeItem = styled(Box)`
  position: relative;
  padding-left: 30px;
  font-size: 18px;
  line-height: 30px;
  list-style: none;

  &:before {
    content: '';
    background: url(${IconCheck});
    position: absolute;
    top: 0;
    left: 0;
    width: 24px;
    height: 24px;
  }
`;

export const ModalSubscribeSubtitle = styled(Box)`
  padding: 10px;
  margin-bottom: 10px;
  text-align: center;
  color: #747474;
`;

export const ModalSubscribePrice = styled(Box)`
  padding: 10px 20px;
  text-align: left;
  color: #747474;
  background: #f7f7f9;
  border-radius: 8px;

  ${(props) =>
    props.settingsItem &&
    css`
      min-height: 50px;
      display: flex;
      margin-bottom: 12px;
      align-items: center;
      font-weight: bold;
      color: #000;
    `}

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${(props) =>
    props.background &&
    css`
      background: ${props.background};
    `}

  ${(props) =>
    props.itemMenu &&
    css`
      justify-content: center;
      text-align: center;
      cursor: pointer;
    `}
`;

export const ModalSubscribePriceNumber = styled.span`
  font-size: 24px;
  font-weight: bold;
  color: #000;
`;

export const ModalSubscribePriceCode = styled.span`
  font-size: 20px;
  font-weight: bold;
  color: #000;
`;

export const EditModalMenuSetting = styled(Box)`
  display: flex;
  position: absolute;
  top: 30px;
  right: 88px;
`;

export const EditModalSettingCircle = styled(Box)`
  margin-left: 2px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #979fa9;
`;

export const DeleteSectionBox = styled(Box)`
  width: 30px;
  flex: none;
  cursor: pointer;

  ${(props) =>
    props.hide &&
    css`
      visibility: hidden;

      @media (max-width: 568px) {
        display: none;
      }
    `}
`;

export const SwitchBox = styled(Box)`
  margin: 0 0 25px 0;
  display: flex;
  align-items: center;

  ${(props) =>
    props.activeLink &&
    css`
      margin: 0 0 0 auto;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.hide &&
    css`
      display: none;
      //visibility: hidden;
    `}

  ${(props) =>
    props.insideTikTokModal &&
    css`
      position: absolute;
      top: 0;
      left: 0;
      justify-content: space-between;
      width: 100%;
      padding: 15px;
      background: rgba(0, 0, 0, 0.5);
    `}
`;

export const SwitchTitle = styled(Box)`
  font-size: 16px;
  margin-right: 15px;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.showOptions &&
    css`
      font-size: 12px;
      color: #1bc3fe;
      cursor: pointer;
      text-transform: uppercase;
    `}

  ${(props) =>
    props.insideTikTokModal &&
    css`
      color: #fff;
    `}
`;

export const SwitchBoxContainer = styled(Box)`
  display: flex;
  align-items: center;
`;

export const SwitchLabel = styled.label`
  flex: none;
  position: relative;
  display: inline-block;
  width: 42px;
  height: 25px;
`;

export const SwitchSpan = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;

  &:before {
    position: absolute;
    content: '';
    height: 17px;
    width: 17px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
`;

export const SwitchInput = styled.input`
  display: none;

  &:checked + ${SwitchSpan} {
    background-color: #2196f3;
  }

  &:focus + ${SwitchSpan} {
    box-shadow: 0 0 1px #2196f3;
  }

  &:checked + ${SwitchSpan}:before {
    transform: translateX(18px);
  }

  ${(props) =>
    props.bgGreen &&
    css`
      &:checked + ${SwitchSpan} {
        background-color: #17ce17;
      }
    `}

  ${(props) =>
    props.activeLink &&
    css`
      &:checked + ${SwitchSpan} {
        background-color: #17ce17;
      }
    `}
`;

export const ModalSettingsText = styled(Box)`
  padding: 5px 10px;
  margin-bottom: 15px;
  margin-top: 10px;
  color: #747474;
  text-align: center;
`;

export const ShareMenuBox = styled(Box)`
  display: none;

  ${(props) =>
    props.isShowing &&
    css`
      display: block;
    `}
`;

export const ShareMenuTitle = styled(Box)`
  text-align: center;
  font-size: 22px;
  //font-weight: bold;
`;

export const ShareMenuList = styled(Box)`
  margin-top: 40px;
  display: flex;
  justify-content: space-around;
`;

export const ShareMenuItem = styled(Box)`
  position: relative;
`;

export const ShareMenuIconCircle = styled(Box)`
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.2);
`;

export const ShareMenuCaption = styled(Box)`
  margin-top: 10px;
  text-align: center;
`;

export const QRCodeBox = styled(Box)`
  display: none;

  ${(props) =>
    props.isShowing &&
    css`
      display: block;
    `}
`;

export const QRCodeTitle = styled(Box)`
  text-align: center;
  font-size: 22px;
`;

export const QRCodeText = styled(Box)`
  margin: 30px 0;
  text-align: center;
`;

export const QRCodeImageBox = styled(Box)`
  height: 300px;
  margin-bottom: 30px;
`;

export const QRCodeImage = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
`;

export const ToggleContentBox = styled(Box)`
  display: flex;
  margin-bottom: 30px;
  border-radius: 30px;
  background: #f9f9fb;
  border: 1px solid #e0e2e9;
`;

export const ToggleContentItem = styled(Box)`
  padding: 10px;

  width: 50%;
  border-radius: 30px;
  text-align: center;

  ${(props) =>
    props.active &&
    css`
      color: #fff;
      background: #006afe;
      cursor: pointer;
    `}
`;

export const PhotoList = styled(Flex)`
  flex: 1;
  flex-wrap: wrap;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
    width: 100%;
    display: block;
  }

  ${(props) =>
    props.templateList &&
    css`
      @media (min-width: 768px) {
        margin-left: 0;
      }
    `}

  ${(props) =>
    props.isEditBox &&
    css`
      display: flex;
      flex-direction: row;

      @media (max-width: 767px) {
        display: flex;
        flex-direction: row;
      }
    `}
`;

export const TemplateBox = styled(Box)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2px;
  user-select: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  &:hover {
    cursor: pointer;
  }

  @media (min-width: 768px) {
    margin-right: 12px;
    width: 17%;
    height: auto;
    padding-bottom: 3%;
    ${(props) =>
      props.five &&
      css`
        margin-right: 0;
      `}
  }

  @media (min-width: 1200px) {
    width: 18%;
    height: auto;
    padding-bottom: 3%;
  }

  @media (max-width: 768px) {
    display: inline-block;
    vertical-align: initial;
    width: 17%;
    height: auto;
    margin-right: 3.5%;
    margin-bottom: 3%;
    padding-top: 31%;
    box-sizing: border-box;
    overflow: hidden;
    ${(props) =>
      props.five &&
      css`
        margin-right: 0;
      `}

    ${(props) =>
      props.isEditBox &&
      css`
        width: 22%;
        padding-top: 41%;
      `}
  }
`;

export const PhotoImg = styled.img`
  display: flex;
  align-self: end;
  max-width: 100%;
  min-height: 100%;
  -moz-appearance: none;
  -webkit-appearance: none;

  @media (min-width: 1200px) {
    width: 100%;
    object-fit: cover;
  }

  @media (max-width: 767px) {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    min-width: 100%;
    min-height: 100%;
    ${(props) =>
      props.checked &&
      css`
        border: 3px #17ce17 solid;
        border-radius: 5%;
        opacity: 1;
      `}
  }

  ${(props) =>
    props.checked &&
    css`
      border: 3px #17ce17 solid;
      border-radius: 5%;
      opacity: 1;
    `}

  ${(props) =>
    props.checked &&
    css`
      border: 3px #17ce17 solid;
      border-radius: 5%;
      opacity: 1;
    `}
  ${(props) =>
    !props.isEdit &&
    css`
      opacity: 0.5;
      filter: grayscale(100%);
    `}
`;

export const ContentSwitchBox = styled(Box)`
  display: flex;
  align-items: center;

  ${(props) =>
    props.isEditBox &&
    css`
      margin-left: 21px;
      border-radius: 50%;
      border: 2px solid #e0e2e9;
      cursor: pointer;
    `}
`;

export const EmptyElement = styled(Box)`
  width: 100%;
  height: 100%;
  min-height: 80px;

  ${(props) =>
    props.isSuccessSubmitOrder &&
    css`
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    `}

  ${(props) =>
    props.isHiding &&
    css`
      display: none;
    `}

  ${(props) =>
    props.isShowing &&
    css`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    `}

  ${(props) =>
    props.insidePayPalPage &&
    css`
      height: 100vh;
    `}

  ${(props) =>
    props.insideDonation &&
    css`
      height: auto;
    `}
`;

export const Header = styled(Box)`
  position: relative;
`;

export const Title = styled(Box)`
  padding: 20px 0;
  font-size: 24px;
  font-weight: bold;
  text-align: center;

  ${(props) =>
    props.insidePayPalPage &&
    css`
      margin-left: 60px;
      text-align: left;
    `}
`;

export const PayPalPageContent = styled(Box)`
  max-width: 500px;
  height: calc(100% - 68px);
  margin: 10px auto 40px auto;
  padding: 0 12px;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${(props) =>
    props.insideDonation &&
    css`
      height: auto;
    `}
`;

export const PayPalPageCaption = styled(Box)`
  font-size: 18px;
  color: #838383;
`;

export const BasketSum = styled(Flex)`
  justify-content: flex-end;
  padding: 0 20px;
  margin: 0 auto 25px auto;
  text-align: right;
  color: #000000;
  font-size: 18px;
  font-weight: bold;
  max-width: 500px;

  ${(props) =>
    props.insideItemAdded &&
    css`
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin: -20px 0 15px;
    `}

  ${(props) =>
    props.insidePayPalPage &&
    css`
      font-size: 30px;
      margin: 45px 0;
    `}
`;

export const BuyButtonWhatsApp = styled(Flex)`
  margin: 30px auto;
  display: flex;
  justify-content: center;
  padding: 0 8px;
  position: relative;
  color: grey;
  width: 95%;
  max-width: 500px;
  height: 40px;
  cursor: pointer;
  border-radius: 6px 6px 6px 6px;
  flex-wrap: wrap;
  background-color: #108c7e;

  ${(props) =>
    props.isBlackBackground &&
    css`
      background: #000000;
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.insidePayPalPage &&
    css`
      margin-top: auto;
    `}
`;

export const InsideBuuton = styled(Flex)`
  color: white;
  margin: auto;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  ${(props) =>
    props.uppercase &&
    css`
      text-transform: uppercase;
    `}
`;

export const PhotoListTitle = styled(Box)`
  margin-top: 20px;
  display: flex;
  padding: 0 12px;
  font-size: 22px;
  font-weight: bold;
`;

export const PhotListTitleText = styled(Box)`
  margin-left: 10px;

  ${(props) =>
    props.insideDonation &&
    css`
      text-align: center;
    `}
`;

export const PaymentsWrapper = styled(Box)`
  display: none;

  ${(props) =>
    props.isShowing &&
    css`
      display: block;
    `}
`;

export const PaymentsBox = styled(Box)`
  padding: 0 20px;

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}
`;

export const PaymentsList = styled(Box)`
  margin-top: 20px;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const PaymentsItem = styled(Box)`
  display: none;
  align-items: center;
  padding: 10px 0;

  ${(props) =>
    props.isShowing &&
    css`
      display: flex;
    `}//outline: 1px solid deeppink;
`;

export const PaymentsTitleBox = styled(Box)`
  position: relative;
  margin-left: 30px;

  ${(props) =>
    props.insideDonation &&
    css`
      margin: 0;
    `}
`;

export const PaymentsIconBox = styled(Box)`
  position: absolute;
  top: -16px;
  left: -4px;

  ${(props) =>
    props.fondy &&
    css`
      top: -5px;
      left: 5px;
    `}
`;

export const PaymentIcon = styled.img`
  width: 30px;
  height: auto;
`;

export const PaymentsTitle = styled(Box)`
  padding-left: 60px;
`;

export const RadioCheckmark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 24px;
  width: 24px;
  background-color: transparent;
  border: 2px solid #e0e2e9;
  border-radius: 50%;

  &:after {
    content: '';
    position: absolute;
    display: none;
    left: 7px;
    top: 3px;
    width: 1px;
    height: 1px;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  ${(props) =>
    props.top &&
    css`
      top: ${props.top};
    `}
`;

export const FaqBox = styled(Box)`
  margin: ${mainIndent} 0;
  background: #fff;
  color: #000;
  border: 1px solid #e0e2e9;
  border-radius: 8px;

  ${(props) =>
    props.bgColor &&
    css`
      background: ${props.bgColor};
    `}

  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}

  ${(props) =>
    !props.isBorder &&
    css`
      border: none;
    `}


  ${(props) =>
    props.isHeader &&
    css`
      padding-top: 26px;
    `}

  ${(props) =>
    props.isFullWidth &&
    css`
      ${fullWidthSection};
    `}

  ${(props) =>
    props.isFullWidth &&
    props.isInsideDashboard &&
    css`
      padding-left: 12px;
      padding-right: 12px;
    `}
  
  ${(props) =>
    props.shadow === 'soft' &&
    css`
      ${shadowSoft};
    `}

  ${(props) =>
    props.shadow === 'hard' &&
    css`
      ${shadowHard};
    `}

  ${(props) =>
    Boolean(props.sectionMargin) &&
    css`
      margin-top: ${props.sectionMargin}px;
      margin-bottom: ${props.sectionMargin}px;
    `}

  ${(props) =>
    Boolean(props.sectionPadding) &&
    css`
      padding-top: ${props.sectionPadding}px;
      padding-bottom: ${props.sectionPadding}px;
    `}
`;

export const FooterWrapperBox = styled(Box)`
  margin-top: auto;
`;

export const FooterBox = styled(Box)`
  margin-top: 70px;
  background: #fff;
  color: #000;

  width: calc(100% + 70px);
  margin-left: -34px;
  padding: 50px 32px 0 32px;

  @media (max-width: 568px) {
    width: 101vw !important;
    margin-left: -14px;
    padding: 50px 12px 12px;
  }

  ${(props) =>
    props.sectionPadding &&
    css`
      padding-top: ${props.sectionPadding}px;
      padding-bottom: ${props.sectionPadding}px;
    `}

  ${(props) =>
    props.bgColor &&
    css`
      background: ${props.bgColor};
    `}

  ${(props) =>
    props.bgImage &&
    css`
      background: url(${props.bgImage}) no-repeat center / cover;
    `}

  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}

  ${(props) =>
    props.isSmooth &&
    css`
      background: transparent;
    `}

  ${(props) =>
    props.isInsideDashboard &&
    css`
      pointer-events: none;
    `}
`;

export const SectionSmoothBackground = styled(Box)`
  margin-top: 70px;
  height: 50px;

  @media (max-width: 568px) {
    width: 101vw !important;
    margin-left: -14px;
  }

  ${(props) =>
    props.bgRGB &&
    css`
      //background: linear-gradient(rgba(${props.bgRGB?.r}, ${props.bgRGB?.g}, ${props.bgRGB?.b}, 0) 0%, rgba(${props.bgRGB?.r}, ${props.bgRGB?.g}, ${props.bgRGB
        ?.b}, 0.43) 51.04%, rgba(${props.bgRGB?.r}, ${props.bgRGB?.g}, ${props.bgRGB?.b}, 0.86) 100%);
      background: linear-gradient(
        rgba(${props.bgRGB?.r}, ${props.bgRGB?.g}, ${props.bgRGB?.b}, 0) 0%,
        rgba(${props.bgRGB?.r}, ${props.bgRGB?.g}, ${props.bgRGB?.b}, 0.78) 51.04%,
        rgb(${props.bgRGB?.r}, ${props.bgRGB?.g}, ${props.bgRGB?.b}) 100%
      );
    `}
`;

export const FaqHeader = styled(Box)`
  text-align: center;
  padding: 15px 10px;
`;

export const FaqList = styled(Box)`
  display: flex;
  flex-direction: column;
  ${({ gap }) =>
    gap &&
    css`
      gap: ${gap};
    `}
`;

export const TwitterBox = styled(Box)`
  margin: ${mainIndent} 0;
`;

export const MusicList = styled(Box)`
  margin: ${mainIndent} 0;
`;

export const MusicItem = styled(Box)`
  text-align: center;
  margin: ${mainIndent} 0;
  color: #000000;
`;

export const MusicCustomItem = styled(Box)`
  height: 125px;

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${(props) =>
    props.background &&
    css`
      background: ${props.background};
    `}

    ${(props) =>
    props.shape === 'square' &&
    css`
      border-radius: 8px !important;

      &:hover {
        border-radius: 8px !important;
      }
    `}
    
      ${(props) =>
    props.shape === 'round' &&
    css`
      border-radius: 36px !important;

      &:hover {
        border-radius: 36px !important;
      }
    `}
  
        ${(props) =>
    props.border === 'solid' &&
    css`
      border: 2px solid ${props.borderColor} !important;

      &:hover {
        border: 2px solid ${props.borderColor} !important;
      }
    `}
        ${(props) =>
    props.border === 'none' &&
    css`
      border: none !important;
      outline: none !important;
    `}
    
          ${(props) =>
    props.shadow === 'hard' &&
    css`
      box-shadow: ${props.shadowColor} 8px 8px 0 0;
    `}
          ${(props) =>
    props.shadow === 'soft' &&
    css`
      ${shadowSoft};
    `}
      
          ${(props) =>
    props.shadow === 'hard' &&
    props.border === 'double' &&
    css`
      box-shadow:
        ${props.shadowColor} 8px 8px 0 0,
        ${props.borderColor} 8px 8px 0 2px;
      border: 2px solid ${props.borderColor} !important;
    `}
`;

export const MusicCoverImageBox = styled(Box)`
  overflow: hidden;
  position: absolute;
  width: 120px;
  height: 120px;
  border-radius: 16px;
`;

export const MusicCoverImage = styled.img`
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 16px;
  padding: 10px;
`;

export const AudioBox = styled(Box)`
  position: absolute;
  top: 50%;
  left: 32px;
  transform: translate(0%, -50%);
  z-index: 20;
  opacity: 0;
`;

export const MusicContent = styled(Box)`
  padding-left: 140px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const MusicTitle = styled(Box)`
  font-size: 18px;
  line-height: 1.2;
  font-weight: bold;
`;

export const MusicArtist = styled(Box)`
  margin-top: 8px;
  font-size: 14px;
  line-height: 1.1;
`;

export const PreviewVideoPlay = styled.button`
  width: 54px;
  height: 54px;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 10;
  background: transparent;
  transform: translate(-50%, -50%);
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
`;

export const FaqItem = styled(Box)`
  border-top: 1px solid #e0e2e9;

  &:first-child {
    ${(props) =>
      !props.isHeader &&
      css`
        border-top: none;
      `}
  }

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}
  ${(props) =>
    props.backgroundColor &&
    css`
      background: ${props.backgroundColor};
    `}

  ${(props) =>
    props.shape === 'round' &&
    css`
      border-radius: 36px !important;

      &:hover {
        border-radius: 36px !important;
      }
    `}

${(props) =>
    props.border === 'solid' &&
    css`
      border: 2px solid ${props.borderColor} !important;

      &:hover {
        border: 2px solid ${props.borderColor} !important;
      }
    `}
${(props) =>
    props.border === 'none' &&
    css`
      border: none !important;
      outline: none !important;
    `}

  ${(props) =>
    props.shadow === 'hard' &&
    css`
      box-shadow: ${props.shadowColor} 8px 8px 0 0;
    `}
  ${(props) =>
    props.shadow === 'soft' &&
    css`
      ${shadowSoft};
    `}

  ${(props) =>
    props.shadow === 'hard' &&
    props.border === 'double' &&
    css`
      box-shadow:
        ${props.shadowColor} 8px 8px 0 0,
        ${props.borderColor} 8px 8px 0 2px;
      border: 2px solid ${props.borderColor} !important;
    `}

${(props) =>
    props.opacity &&
    css`
      opacity: ${props.opacity};
    `}
`;

export const FaqHeading = styled(Box)`
  padding: 15px 10px;
  display: flex;
  align-items: center;

  ${(props) =>
    !props.isIcon &&
    css`
      padding-left: 20px;
    `}
`;

export const FaqIconBox = styled(Box)`
  flex: none;
  width: 40px;
  height: 40px;
  margin-right: 15px;
`;

export const FaqTitle = styled(Box)`
  width: 100%;
`;

export const FaqContent = styled(Box)`
  padding: 15px 10px 15px 15px;

  ul {
    padding: 0 0 0 20px;
  }

  img {
    width: 100% !important;
    height: auto !important;
  }

  p {
    line-height: 1.6;
  }
`;

export const BannerTextBox = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 88;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  padding: 30px;

  //overflow: hidden;
  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}

  ${(props) =>
    props.isSmallerTop &&
    css`
      top: 35%;
    `}

  ${(props) =>
    props.headerCoverTextPosition &&
    css`
      top: ${props.headerCoverTextPosition}%;
    `}
`;

export const BannerTitle = styled(Box)`
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 15px;
`;

export const BannerText = styled(Box)`
  font-size: 16px;
`;

export const BannerButton = styled(Box)`
  position: absolute;
  top: 0;
  margin: 10px auto;
  width: 280px;
  left: 0;
  right: 0;
  z-index: 1 !important;
  display: flex;
  justify-content: center;

  ${(props) =>
    props.position &&
    css`
      position: ${props.position};
      width: auto;
    `}
  ${(props) =>
    props.isContacts &&
    css`
      bottom: -105px;
    `}

  ${(props) =>
    props.coverCTAMargin &&
    css`
      top: ${props.coverCTAMargin}%;
    `}
`;

export const BannerTimer = styled(Box)`
  //position: absolute;
  //bottom: -44px;
  //margin: 10px auto;
  //width: 280px;
  //left: 0;
  //right: 0;
`;

export const FormFieldTitle = styled(Box)`
  text-align: left;
  font-size: 16px;
  font-weight: normal;
  color: #000000;
  margin: 10px 0;
`;

export const FormErrorBox = styled(Box)`
  display: none;
  // margin: 10px 0;
  color: red;
  font-size: 16px;

  ${(props) =>
    props.isShowing &&
    css`
      display: block;
    `}
`;

// /* look */

export const LookWrap = styled(Box)`
  padding: 0 12px;
`;

export const LookHeader = styled(Box)``;

export const LookTitle = styled(Box)`
  margin: 30px 0;
  text-align: center;
  font-weight: bold;
  font-size: 24px;
  cursor: pointer;
`;

export const LookSubtitleBox = styled(Box)`
  display: flex;
  align-items: center;
`;

export const LookLine = styled(Box)`
  width: 100%;
  background: rgb(245, 245, 245);
  height: 3px;

  ${(props) =>
    props.isHide &&
    css`
      display: none;
    `}
`;

export const LookSubtitle = styled(Box)`
  min-width: 90px;
  text-align: center;
  font-size: 14px;
  text-transform: uppercase;
`;

export const LookList = styled(Box)``;

export const LookItem = styled(Box)`
  margin-top: 35px;
`;

export const LookItemTitle = styled(Box)`
  margin-bottom: 15px;
  font-size: 32px;
  text-align: center;
`;

export const LookItemText = styled(Box)`
  margin: 15px 0;
  font-size: 18px;
  color: #8f8f8f;
`;

export const LookItemPrice = styled(Box)`
  margin-top: 3px;
`;

export const LookSelect = styled.select`
  padding: 10px 15px;
  border-radius: 8px;
  background: #fff;
  border-color: rgba(58, 66, 93, 0.2);
`;

export const LookCheckoutBox = styled(Box)`
  display: none;
  margin-top: 50px;

  ${(props) =>
    props.isShowing &&
    css`
      display: block;
    `}
`;

export const LookCheckoutHeader = styled(Box)`
  margin: 25px 0;
  display: flex;
  justify-content: space-between;
`;

export const LookCheckoutTitle = styled(Box)`
  font-size: 14px;
`;

export const LookCheckoutTotal = styled(Box)`
  font-size: 16px;
`;

export const LookFooter = styled(Box)`
  padding: 50px 0;
  font-size: 12px;
  text-align: center;

  span {
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
  }

  ${(props) =>
    props.isCheckout &&
    css`
      padding-bottom: 30px;
    `}
`;

export const AdditionalBox = styled(Box)`
  display: flex;
  flex-direction: column;

  ${(props) =>
    props.hide &&
    css`
      @media (max-width: 767px) {
        display: none;
      }
    `}
`;

export const AdditionalHeadingBox = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AdditionalBoxHide = styled(Box)`
  ${(props) =>
    props.isHideOnlyMobile &&
    css`
      @media (max-width: 767px) {
        display: none;
      }
    `}

  ${(props) =>
    !props.isHideOnlyMobile &&
    css`
      display: none;
    `}

  ${(props) =>
    props.editBox &&
    css`
      height: 85px;
    `}

  ${(props) =>
    props.isActive &&
    css`
      display: block;
    `}
`;

export const AdditionalTitle = styled.span`
  padding: 0 10px;
  display: inline-flex;
  cursor: pointer;

  ${(props) =>
    props.bottom &&
    css`
      margin: 15px 0;
      text-align: center;
      display: flex;
      justify-content: center;
    `}

  ${(props) =>
    props.left &&
    css`
      margin: 30px 0 10px 0;
      text-align: left;
    `}
  

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}
`;

export const AdditionalText = styled.span`
  max-width: 305px;
  display: block;
  font-size: 12px;
  text-align: left;

  @media (max-width: 767px) {
    max-width: 100%;
  }
`;

export const AdditionalIcon = styled.img`
  margin-top: 2px;
  padding: 0 10px;

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.isActive &&
    css`
      transform: rotate(180deg);
    `}
`;

export const WalletBox = styled(Box)`
  margin-bottom: ${mainIndent};
  margin-top: ${mainIndent};
`;

export const WalletList = styled(Box)``;

export const WalletItem = styled(Box)`
  margin-top: 12px;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f2f2f2;
  border-radius: 12px;
`;

export const WalletInfo = styled(Box)``;

export const WalletTitleBox = styled(Box)`
  display: flex;
`;

export const WalletIcon = styled.img`
  width: 18px;
  height: 18px;
  flex: none;
  margin-right: 5px;
  border-radius: 50%;
`;

export const WalletTitle = styled(Box)`
  margin-bottom: 7px;
  font-size: 14px;
  color: #adadad;
`;

export const WalletHeader = styled(Box)`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${(props) =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}
`;

export const WalletDescription = styled(Box)`
  font-size: 18px;

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${(props) =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}

  ${(props) =>
    props.insideModal &&
    css`
      margin-top: -15px;
      padding-right: 40px;
    `}

  ${(props) =>
    props.insideWallet &&
    css`
      margin-bottom: 10px;
    `}
`;

export const WalletValue = styled(Box)`
  font-size: 16px;
  color: #5a5a5a;

  overflow: hidden;
  text-overflow: ellipsis;
`;

export const WalletSettings = styled(Box)``;

export const WalletActionBox = styled(Box)`
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #e3e3e3;

  ${(props) =>
    props.isTransparent &&
    css`
      width: 50px;
      height: 50px;
      background: transparent;
    `}
`;

export const MapTitle = styled(Box)`
  text-align: center;
  font-size: 20px;
  font-weight: bold;

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${(props) =>
    props.isMarginBottom &&
    css`
      margin-bottom: 15px;
    `}
`;

export const MapText = styled(Box)`
  text-align: center;
  margin: 10px 0 15px;

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}
`;

export const FooterContactsList = styled(Box)`
  margin: 12px 0;
`;

export const FooterContactsItem = styled(Box)`
  padding-left: 8px;
  display: flex;
  align-items: center;
`;

export const FooterContactsIcon = styled(Box)``;

export const FooterContactsTitle = styled(Box)`
  margin-left: 15px;
`;

export const NftList = styled(Box)``;

export const NftItem = styled(Box)`
  margin-bottom: ${mainIndent};
  margin-top: ${mainIndent};

  .card {
    width: 100vw !important;
  }
`;

export const SliderPhotoList = styled(Box)`
  margin: 20px 0;

  .slick-slide {
    //width: 150px !important;
    margin-right: 15px;
    //height: 150px;
  }
`;

export const LinkPageImage = styled.img`
  width: 100%;
  height: 225px;
  object-fit: cover;
  border-radius: 3px;
`;

export const LinkPageTitle = styled(Box)`
  margin: 20px 0;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
`;

export const LinkPageText = styled(Box)`
  ${(props) =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}

  ${(props) =>
    props.isError &&
    css`
      color: red;
      font-weight: bold;
    `}
`;

export const DatePickerWrapper = styled(Box)`
  margin: 20px 0 0 0;
  text-align: center;
`;

export const LinkButtonsWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
`;

export const LinkPageInput = styled(Box)`
  margin-top: 20px;
  text-align: center;
  width: 100%;
`;
